export const departments = [
    { 
        code: "01", 
        name: "Amazonas",
        provinces:[
            { 
                name: "Chachapoyas", 
                code: "0101",
                districts: [
                    { name: "Chachapoyas", code: "010101" },
                    { name: "Asuncion", code: "010102" },
                    { name: "Balsas", code: "010103" },
                    { name: "Cheto", code: "010104" },
                    { name: "Chiliquin", code: "010105" },
                    { name: "Chuquibamba", code: "010106" },
                    { name: "Granada", code: "010107" },
                    { name: "Huancas", code: "010108" },
                    { name: "La Jalca", code: "010109" },
                    { name: "Leimebamba", code: "010110" },
                    { name: "Levanto", code: "010111" },
                    { name: "Magdalena", code: "010112" },
                    { name: "Mariscal Castilla", code: "010113" },
                    { name: "Molinopampa", code: "010114" },
                    { name: "Montevideo", code: "010115" },
                    { name: "Olleros", code: "010116" },
                    { name: "Quinjalca", code: "010117" },
                    { name: "San Francisco de Daguas", code: "010118" },
                    { name: "San Isidro de Maino", code: "010119" },
                    { name: "Soloco", code: "010120" },
                    { name: "Sonche", code: "010121" }
                ] 
            },
            { 
                name: "Bagua", 
                code: "0102",
                districts: [
                    { name: 'Bagua', code: '010201' },
                    { name: 'Aramango', code: '010202' },
                    { name: 'Copallin', code: '010203' },
                    { name: 'El Parco', code: '010204' },
                    { name: 'Imaza', code: '010205' },
                    { name: 'La Peca', code: '010206' }
                ] 
            },
            { 
                name: "Bongara", 
                code: "0103",
                districts:[
                    { name: 'Jumbilla', code: '010301' },
                    { name: 'Chisquilla', code: '010302' },
                    { name: 'Churuja', code: '010303' },
                    { name: 'Corocha', code: '010304' },
                    { name: 'Cuispes', code: '010305' },
                    { name: 'Florida', code: '010306' },
                    { name: 'Jazan', code: '010307' },
                    { name: 'Recta', code: '010308' },
                    { name: 'San Carlos', code: '010309' },
                    { name: 'Shipasbamba', code: '010310' },
                    { name: 'Valera', code: '010311' },
                    { name: 'Yambrasbamba', code: '010312' }
                ] 
            },
            { 
                name: "Condorcanqui", 
                code: "0104",
                districts:[
                    { name: 'Nieva', code: '010401' },
                    { name: 'El Cenepa', code: '010402' },
                    { name: 'Río Santiago', code: '010403' }
                ] 
            },
            { 
                name: "Luya", 
                code: "0105",
                districts:[
                    { name: 'Lamud', code: '010501' },
                    { name: 'Camporredondo', code: '010502' },
                    { name: 'Cocabamba', code: '010503' },
                    { name: 'Colcamar', code: '010504' },
                    { name: 'Conila', code: '010505' },
                    { name: 'Inguilpata', code: '010506' },
                    { name: 'Longuita', code: '010507' },
                    { name: 'Lonya Chico', code: '010508' },
                    { name: 'Luya', code: '010509' },
                    { name: 'Luya Viejo', code: '010510' },
                    { name: 'Maria', code: '010511' },
                    { name: 'Ocalli', code: '010512' },
                    { name: 'Ocumal', code: '010513' },
                    { name: 'Pisuquia', code: '010514' },
                    { name: 'Providencia', code: '010515' },
                    { name: 'San Cristobal', code: '010516' },
                    { name: 'San Francisco del Yeso', code: '010517' },
                    { name: 'San Jeronimo', code: '010518' },
                    { name: 'San Juan de Lopecancha', code: '010519' },
                    { name: 'Santa Catalina', code: '010520' },
                    { name: 'Santo Tomas', code: '010521' },
                    { name: 'Tingo', code: '010522' },
                    { name: 'Trita', code: '010523' }
                ] 
            },
            { 
                name: "Rodriguez de Mendoza", 
                code: "0106",
                districts:[
                    { name: "San Nicolas", code: "010601" },
                    { name: "Chirimoto", code: "010602" },
                    { name: "Cochamal", code: "010603" },
                    { name: "Huambo", code: "010604" },
                    { name: "Limabamba", code: "010605" },
                    { name: "Longar", code: "010606" },
                    { name: "Mariscal Benavides", code: "010607" },
                    { name: "Milpuc", code: "010608" },
                    { name: "Omia", code: "010609" },
                    { name: "Santa Rosa", code: "010610" },
                    { name: "Totora", code: "010611" },
                    { name: "Vista Alegre", code: "010612" }
                ] 
            },
            { 
                name: "Utcubamba", 
                code: "0107",
                districts:[
                    { name: "Bagua Grande", code: "010701" },
                    { name: "Cajaruro", code: "010702" },
                    { name: "Cumba", code: "010703" },
                    { name: "El Milagro", code: "010704" },
                    { name: "Jamalca", code: "010705" },
                    { name: "Lonya Grande", code: "010706" },
                    { name: "Yamon", code: "010707" }
                ]
            }
        ]
    },
    { 
        code: "02", 
        name: "Ancash",
        provinces:[
            { 
                name: 'Huaraz', 
                code: '0201',
                districts:[
                    { name: "Huaraz", code: "020101" },
                    { name: "Cochabamba", code: "020102" },
                    { name: "Colcabamba", code: "020103" },
                    { name: "Huanchay", code: "020104" },
                    { name: "Independencia", code: "020105" },
                    { name: "Jangas", code: "020106" },
                    { name: "La Libertad", code: "020107" },
                    { name: "Olleros", code: "020108" },
                    { name: "Pampas Grande", code: "020109" },
                    { name: "Pariacoto", code: "020110" },
                    { name: "Pira", code: "020111" },
                    { name: "Tarica", code: "020112" },
                ] 
            },
            { 
                name: 'Aija', 
                code: '0202',
                districts:[
                    { name: 'Aija', code: '020201' },
                    { name: 'Coris', code: '020202' },
                    { name: 'Huacllan', code: '020203' },
                    { name: 'La Merced', code: '020204' },
                    { name: 'Succha', code: '020205' },
                ] 
            },
            { 
                name: 'Antonio Raymondi', 
                code: '0203',
                districts:[
                    { name: "Llamellin", code: "020301" },
                    { name: "Aczo", code: "020302" },
                    { name: "Chaccho", code: "020303" },
                    { name: "Chingas", code: "020304" },
                    { name: "Mirgas", code: "020305" },
                    { name: "San Juan de Rontoy", code: "020306" }
                ] 
            },
            { 
                name: 'Asuncion', 
                code: '0204',
                districts: [
                    { name: "Chacas", code:"020401" },
                    { name: "Acochaca", code:"020402" }
                ]
            },
            { 
                name: 'Bolognesi', 
                code: '0205',
                districts: [
                    { name: "Chiquian", code: "020501" },
                    { name: "Abelardo Pardo Lezameta", code: "020502" },
                    { name: "Antonio Raymondi", code: "020503" },
                    { name: "Aquia", code: "020504" },
                    { name: "Cajacay", code: "020505" },
                    { name: "Canis", code: "020506" },
                    { name: "Colquioc", code: "020507" },
                    { name: "Huallanca", code: "020508" },
                    { name: "Huasta", code: "020509" },
                    { name: "Huayllacayan", code: "020510" },
                    { name: "La Primavera", code: "020511" },
                    { name: "Mangas", code: "020512" },
                    { name: "Pacllon", code: "020513" },
                    { name: "San Miguel de Corpanqui", code: "020514" },
                    { name: "Ticllos", code: "020515" }
                ]
            },
            { 
                name: 'Carhuaz', 
                code: '0206',
                districts: [
                    { name: 'Carhuaz', code: '020601' },
                    { name: 'Acopampa', code: '020602' },
                    { name: 'Amashca', code: '020603' },
                    { name: 'Anta', code: '020604' },
                    { name: 'Ataquero', code: '020605' },
                    { name: 'Marcara', code: '020606' },
                    { name: 'Pariahuanca', code: '020607' },
                    { name: 'San Miguel de Aco', code: '020608' },
                    { name: 'Shilla', code: '020609' },
                    { name: 'Tinco', code: '020610' },
                    { name: 'Yungar', code: '020611' }
                ]
            },
            { 
                name: 'Carlos Fermin Fitzcarrald', 
                code: '0207',
                districts:[
                    { name: 'San Luis', code:'020701'},
                    { name: 'San Nicolas', code:'020702'},
                    { name: 'Yauya', code:'020703'}
                ] 
            },
            { 
                name: 'Casma', 
                code: '0208',
                districts:[
                    { name: 'Casma', code: '020801' },
                    { name: 'Buena Vista Alta', code: '020802' },
                    { name: 'Comandante Noel', code: '020803' },
                    { name: 'Yautan', code: '020804' },
                ] 
            },
            { 
                name: 'Corongo', 
                code: '0209',
                districts:[
                    { name: "Corongo", code: "020901" },
                    { name: "Aco", code: "020902" },
                    { name: "Bambas", code: "020903" },
                    { name: "Cusca", code: "020904" },
                    { name: "La Pampa", code: "020905" },
                    { name: "Yanac", code: "020906" },
                    { name: "Yupan", code: "020907" }
                ] 
            },
            { 
                name: 'Huari', 
                code: '0210',
                districts:[
                    { name: "Huari", code: "021001" },
                    { name: "Anra", code: "021002" },
                    { name: "Cajay", code: "021003" },
                    { name: "Chavin de Huantar", code: "021004" },
                    { name: "Huacachi", code: "021005" },
                    { name: "Huacchis", code: "021006" },
                    { name: "Huachis", code: "021007" },
                    { name: "Huantar", code: "021008" },
                    { name: "Masin", code: "021009" },
                    { name: "Paucas", code: "021010" },
                    { name: "Ponto", code: "021011" },
                    { name: "Rahuapampa", code: "021012" },
                    { name: "Rapayan", code: "021013" },
                    { name: "San Marcos", code: "021014" },
                    { name: "San Pedro de Chana", code: "021015" },
                    { name: "Uco", code: "021016" }
                ] 
            },
            { 
                name: 'Huarmey', 
                code: '0211',
                districts: [
                    { name: 'Huarmey', code: '021101' },
                    { name: 'Cochapeti', code: '021102' },
                    { name: 'Culebras', code: '021103' },
                    { name: 'Huayan', code: '021104' },
                    { name: 'Malvas', code: '021105' }
                ]
            },
            { 
                name: 'Huaylas', 
                code: '0212',
                districts: [
                    { name: "Caraz", code: "021201" },
                    { name: "Huallanca", code: "021202" },
                    { name: "Huata", code: "021203" },
                    { name: "Huaylas", code: "021204" },
                    { name: "Mato", code: "021205" },
                    { name: "Pamparomas", code: "021206" },
                    { name: "Pueblo Libre", code: "021207" },
                    { name: "Santa Cruz", code: "021208" },
                    { name: "Santo Toribio", code: "021209" },
                    { name: "Yuracmarca", code: "021210" }
                ]
            },
            { 
                name: 'Mariscal Luzuriaga', 
                code: '0213',
                districts: [
                    { name: "Piscobamba", code: "021301" },
                    { name: "Casca", code: "021302" },
                    { name: "Eleazar Guzman Barron", code: "021303" },
                    { name: "Fidel Olivas Escudero", code: "021304" },
                    { name: "Llama", code: "021305" },
                    { name: "Llumpa", code: "021306" },
                    { name: "Lucma", code: "021307" },
                    { name: "Musga", code: "021308" }
                ] 
            },
            { 
                name: 'Ocros', 
                code: '0214',
                districts:[
                    { name: "Ocros", code: "021401" },
                    { name: "Acas", code: "021402" },
                    { name: "Cajamarquilla", code: "021403" },
                    { name: "Carhuapampa", code: "021404" },
                    { name: "Cochas", code: "021405" },
                    { name: "Congas", code: "021406" },
                    { name: "Llipa", code: "021407" },
                    { name: "San Cristobal de Rajan", code: "021408" },
                    { name: "San Pedro", code: "021409" },
                    { name: "Santiago De Chilcas", code: "021410" }
                ] 
            },
            { 
                name: 'Pallasca', 
                code: '0215',
                districts:[
                    { name: 'Cabana', code: '021501' },
                    { name: 'Bolognesi', code: '021502' },
                    { name: 'Conchucos', code: '021503' },
                    { name: 'Huacaschuque', code: '021504' },
                    { name: 'Huandoval', code: '021505' },
                    { name: 'Lacabamba', code: '021506' },
                    { name: 'Llapo', code: '021507' },
                    { name: 'Pallasca', code: '021508' },
                    { name: 'Pampas', code: '021509' },
                    { name: 'Santa Rosa', code: '021510' },
                    { name: 'Tauca', code: '021511' }
                ] 
            },
            { 
                name: 'Pomabamba', 
                code: '0216',
                districts:[
                    { name: 'Pomabamba', code: '021601' },
                    { name: 'Huayllan', code: '021602' },
                    { name: 'Parobamba', code: '021603' },
                    { name: 'Quinuabamba', code: '021604' }
                ] 
            },
            { 
                name: 'Recuay', 
                code: '0217',
                districts:[
                    { name: 'Recuay', code: '021701' },
                    { name: 'Catac', code: '021702' },
                    { name: 'Cotaparaco', code: '021703' },
                    { name: 'Huayllapampa', code: '021704' },
                    { name: 'Llacllin', code: '021705' },
                    { name: 'Marca', code: '021706' },
                    { name: 'Pampas Chico', code: '021707' },
                    { name: 'Pararin', code: '021708' },
                    { name: 'Tapacocha', code: '021709' },
                    { name: 'Ticapampa', code: '021710' },
                ] 
            },
            { 
                name: 'Santa', 
                code: '0218',
                districts:[
                    { name: "Chimbote", code: "021801" },
                    { name: "Caceres del Peru", code: "021802" },
                    { name: "Coishco", code: "021803" },
                    { name: "Macate", code: "021804" },
                    { name: "Moro", code: "021805" },
                    { name: "Nepeña", code: "021806" },
                    { name: "Samanco", code: "021807" },
                    { name: "Santa", code: "021808" },
                    { name: "Nuevo Chimbote", code: "021809" }
                ] 
            },
            { 
                name: 'Sihuas', 
                code: '0219',
                districts:[
                    { name: "Sihuas", code: "021901" },
                    { name: "Acobamba", code: "021902" },
                    { name: "Alfonso Ugarte", code: "021903" },
                    { name: "Cashapampa", code: "021904" },
                    { name: "Chingalpo", code: "021905" },
                    { name: "Huayllabamba", code: "021906" },
                    { name: "Quiches", code: "021907" },
                    { name: "Ragash", code: "021908" },
                    { name: "San Juan", code: "021909" },
                    { name: "Sicsibamba", code: "021910" }
                ] 
            },
            { 
                name: 'Yungay', 
                code: '0220',
                districts:[
                    { name: "Yungay", code: "022001" },
                    { name: "Cascapara", code: "022002" },
                    { name: "Mancos", code: "022003" },
                    { name: "Matacoto", code: "022004" },
                    { name: "Quillo", code: "022005" },
                    { name: "Ranrahirca", code: "022006" },
                    { name: "Shupluy", code: "022007" },
                    { name: "Yanama", code: "022008" },
                ] 
            },
        ] 
    },
    { 
        code: "03", 
        name: "Apurimac",
        provinces:[
            { 
                name: "Abancay", 
                code:"0301",
                districts:[
                    { name: "Abancay", code: "030101" },
                    { name: "Chacoche", code: "030102" },
                    { name: "Circa", code: "030103" },
                    { name: "Curahuasi", code: "030104" },
                    { name: "Huanipaca", code: "030105" },
                    { name: "Lambrama", code: "030106" },
                    { name: "Pichirhua", code: "030107" },
                    { name: "San Pedro de Cachora", code: "030108" },
                    { name: "Tamburco", code: "030109" }
                ]
            },
            { 
                name: "Andahuaylas", 
                code: "0302",
                districts: [
                    { name: 'Andahuaylas', code: '030201' },
                    { name: 'Andarapa', code: '030202' },
                    { name: 'Chiara', code: '030203' },
                    { name: 'Huancarama', code: '030204' },
                    { name: 'Huancaray', code: '030205' },
                    { name: 'Huayana', code: '030206' },
                    { name: 'Kishuara', code: '030207' },
                    { name: 'Pacobamba', code: '030208' },
                    { name: 'Pacucha', code: '030209' },
                    { name: 'Pampachiri', code: '030210' },
                    { name: 'Pomacocha', code: '030211' },
                    { name: 'San Antonio de Cachi', code: '030212' },
                    { name: 'San Jeronimo', code: '030213' },
                    { name: 'San Miguel de Chaccrampa', code: '030214' },
                    { name: 'Santa Maria de Chicmo', code: '030215' },
                    { name: 'Talavera', code: '030216' },
                    { name: 'Tumay Huaraca', code: '030217' },
                    { name: 'Turpo', code: '030218' },
                    { name: 'Kaquiabamba', code: '030219' }
                ]
            },
            { 
                name: "Antabamba", 
                code: "0303",
                districts:[
                    { name: "Antabamba", code: "030301" },
                    { name: "El Oro", code: "030302" },
                    { name: "Huaquirca", code: "030303" },
                    { name: "Juan Espinoza Medrano", code: "030304" },
                    { name: "Oropesa", code: "030305" },
                    { name: "Pachaconas", code: "030306" },
                    { name: "Sabaino", code: "030307" }
                ] 
            },
            { 
                name: "Aymaraes", 
                code: "0304",
                districts:[
                    { name: 'Chalhuanca', code: '030401' },
                    { name: 'Capaya', code: '030402' },
                    { name: 'Caraybamba', code: '030403' },
                    { name: 'Chapimarca', code: '030404' },
                    { name: 'Colcabamba', code: '030405' },
                    { name: 'Cotaruse', code: '030406' },
                    { name: 'Huayllo', code: '030407' },
                    { name: 'Justo Apu Sahuaraura', code: '030408' },
                    { name: 'Lucre', code: '030409' },
                    { name: 'Pocohuanca', code: '030410' },
                    { name: 'San Juan de Chacña', code: '030411' },
                    { name: 'Sañayca', code: '030412' },
                    { name: 'Soraya', code: '030413' },
                    { name: 'Tapairihua', code: '030414' },
                    { name: 'Tintay', code: '030415' },
                    { name: 'Toraya', code: '030416' },
                    { name: 'Yanaca', code: '030417' },
                ]
            },
            { 
                name: "Cotabambas", 
                code: "0305",
                districts: [
                    { name: 'Tambobamba', code: '030501' },
                    { name: 'Cotabambas', code: '030502' },
                    { name: 'Coyllurqui', code: '030503' },
                    { name: 'Haquira', code: '030504' },
                    { name: 'Mara', code: '030505' },
                    { name: 'Challhuahuacho', code: '030506' }
                ]
            },
            { 
                name: "Chincheros", 
                code: "0306",
                districts: [
                    { name: 'Chincheros', code: '030601' },
                    { name: 'Anco-Huallo', code: '030602' },
                    { name: 'Cocharcas', code: '030603' },
                    { name: 'Huaccana', code: '030604' },
                    { name: 'Ocobamba', code: '030605' },
                    { name: 'Ongoy', code: '030606' },
                    { name: 'Uranmarca', code: '030607' },
                    { name: 'Ranracancha', code: '030608' },
                ] 
            },
            { 
                name: "Grau", 
                code: "0307",
                districts:[
                    { name: "Chuquibambilla", code: "030701" },
                    { name: "Curpahuasi", code: "030702" },
                    { name: "Gamarra", code: "030703" },
                    { name: "Huayllati", code: "030704" },
                    { name: "Mamara", code: "030705" },
                    { name: "Micaela Bastidas", code: "030706" },
                    { name: "Pataypampa", code: "030707" },
                    { name: "Progreso", code: "030708" },
                    { name: "San Antonio", code: "030709" },
                    { name: "Santa Rosa", code: "030710" },
                    { name: "Turpay", code: "030711" },
                    { name: "Vilcabamba", code: "030712" },
                    { name: "Virundo", code: "030713" },
                    { name: "Curasco", code: "030714" },
                ] 
            }
        ] 
    },
    { 
        code: "04", 
        name: "Arequipa",
        provinces: [
            { 
                name: 'Arequipa', 
                code: '0401',
                districts: [
                    { name: "Arequipa", code: "040101" },
                    { name: "Alto Selva Alegre", code: "040102" },
                    { name: "Cayma", code: "040103" },
                    { name: "Cerro Colorado", code: "040104" },
                    { name: "Characato", code: "040105" },
                    { name: "Chiguata", code: "040106" },
                    { name: "Jacobo Hunter", code: "040107" },
                    { name: "La Joya", code: "040108" },
                    { name: "Mariano Melgar", code: "040109" },
                    { name: "Miraflores", code: "040110" },
                    { name: "Mollebaya", code: "040111" },
                    { name: "Paucarpata", code: "040112" },
                    { name: "Pocsi", code: "040113" },
                    { name: "Polobaya", code: "040114" },
                    { name: "Quequeña", code: "040115" },
                    { name: "Sabandia", code: "040116" },
                    { name: "Sachaca", code: "040117" },
                    { name: "San Juan de Siguas", code: "040118" },
                    { name: "San Juan de Tarucani", code: "040119" },
                    { name: "Santa Isabel de Siguas", code: "040120" },
                    { name: "Santa Rita de Siguas", code: "040121" },
                    { name: "Socabaya", code: "040122" },
                    { name: "Tiabaya", code: "040123" },
                    { name: "Uchumayo", code: "040124" },
                    { name: "Vitor", code: "040125" },
                    { name: "Yanahuara", code: "040126" },
                    { name: "Yarabamba", code: "040127" },
                    { name: "Yura", code: "040128" },
                    { name: "Jose Luis Bustamente Y Rive", code: "040129" },
                ] 
            },
            { 
                name: 'Camana', 
                code: '0402',
                districts:[
                    { name: "Camana", code: "040201" },
                    { name: "Jose Maria Quimper", code: "040202" },
                    { name: "Mariano Nicolas Valcarcel", code: "040203" },
                    { name: "Mariscal Caceres", code: "040204" },
                    { name: "Nicolas de Pierola", code: "040205" },
                    { name: "Ocoña", code: "040206" },
                    { name: "Quilca", code: "040207" },
                    { name: "Samuel Pastor", code: "040208" }
                ] 
            },
            { 
                name: 'Caraveli', 
                code: '0403',
                districts:[
                    { name: "Caraveli", code: "040301" },
                    { name: "Acari", code: "040302" },
                    { name: "Atico", code: "040303" },
                    { name: "Atiquipa", code: "040304" },
                    { name: "Bella Union", code: "040305" },
                    { name: "Cahuacho", code: "040306" },
                    { name: "Chala", code: "040307" },
                    { name: "Chaparra", code: "040308" },
                    { name: "Huanuhuanu", code: "040309" },
                    { name: "Jaqui", code: "040310" },
                    { name: "Lomas", code: "040311" },
                    { name: "Quicacha", code: "040312" },
                    { name: "Yauca", code: "040313" },
                ] 
            },
            { 
                name: 'Castilla', 
                code: '0404',
                districts:[
                    { name: 'Aplao', code: '040401' },
                    { name: 'Andagua', code: '040402' },
                    { name: 'Ayo', code: '040403' },
                    { name: 'Chachas', code: '040404' },
                    { name: 'Chilcaymarca', code: '040405' },
                    { name: 'Choco', code: '040406' },
                    { name: 'Huancarqui', code: '040407' },
                    { name: 'Machaguay', code: '040408' },
                    { name: 'Orcopampa', code: '040409' },
                    { name: 'Pampacolca', code: '040410' },
                    { name: 'Tipan', code: '040411' },
                    { name: 'Uñon', code: '040412' },
                    { name: 'Uraca', code: '040413' },
                    { name: 'Viraco', code: '040414' }
                ] 
            },
            { 
                name: 'Caylloma', 
                code: '0405',
                districts:[
                    { name: "Chivay", code: "040501" },
                    { name: "Achoma", code: "040502" },
                    { name: "Cabanaconde", code: "040503" },
                    { name: "Callalli", code: "040504" },
                    { name: "Caylloma", code: "040505" },
                    { name: "Coporaque", code: "040506" },
                    { name: "Huambo", code: "040507" },
                    { name: "Huanca", code: "040508" },
                    { name: "Ichupampa", code: "040509" },
                    { name: "Lari", code: "040510" },
                    { name: "Lluta", code: "040511" },
                    { name: "Maca", code: "040512" },
                    { name: "Madrigal", code: "040513" },
                    { name: "San Antonio de Chuca", code: "040514" },
                    { name: "Sibayo", code: "040515" },
                    { name: "Tapay", code: "040516" },
                    { name: "Tisco", code: "040517" },
                    { name: "Tuti", code: "040518" },
                    { name: "Yanque", code: "040519" },
                    { name: "Majes", code: "040520" }
                ]
            },
            { 
                name: 'Condesuyos', 
                code: '0406',
                districts:[  
                    { name: "Chuquibamba", code: "040601" },  
                    { name: "Andaray", code: "040602" },  
                    { name: "Cayarani", code: "040603" },  
                    { name: "Chichas", code: "040604" },  
                    { name: "Iray", code: "040605" },  
                    { name: "Rio Grande", code: "040606" },
                    { name: "Salamanca", code: "040607" },
                    { name: "Yanaquihua", code: "040608" },
                ] 
            },
            { 
                name: 'Islay', 
                code: '0407',
                districts:[
                    { name: "Mollendo", code: "040701" },
                    { name: "Cocachacra", code: "040702" },
                    { name: "Dean Valdivia", code: "040703" },
                    { name: "Islay", code: "040704" },
                    { name: "Mejia", code: "040705" },
                    { name: "Punta de Bombon", code: "040706" }
                ] 
            },
            { 
                name: 'La Union', 
                code: '0408',
                districts:[
                    { name: "Cotahuasi", code: "040801" },
                    { name: "Alca", code: "040802" },
                    { name: "Charcana", code: "040803" },
                    { name: "Huaynacotas", code: "040804" },
                    { name: "Pampamarca", code: "040805" },
                    { name: "Puyca", code: "040806" },
                    { name: "Quechualla", code: "040807" },
                    { name: "Sayla", code: "040808" },
                    { name: "Tauria", code: "040809" },
                    { name: "Tomepampa", code: "040810" },
                    { name: "Toro", code: "040811" }
                ] 
            }
        ] 
    },
    { 
        code: "05", 
        name: "Ayacucho",
        provinces: [
            { 
                name: "Huamanga", 
                code: "0501",
                districts: [
                    { name: 'Ayacucho', code: '050101' },
                    { name: 'Acocro', code: '050102' },
                    { name: 'Acos Vinchos', code: '050103' },
                    { name: 'Carmen Alto', code: '050104' },
                    { name: 'Chiara', code: '050105' },
                    { name: 'Ocros', code: '050106' },
                    { name: 'Pacaycasa', code: '050107' },
                    { name: 'Quinua', code: '050108' },
                    { name: 'San Jose de Ticllas', code: '050109' },
                    { name: 'San Juan Bautista', code: '050110' },
                    { name: 'Santiago de Pischa', code: '050111' },
                    { name: 'Socos', code: '050112' },
                    { name: 'Tambillo', code: '050113' },
                    { name: 'Vinchos', code: '050114' },
                    { name: 'Jesus Nazareno', code: '050115' },
                ] 
            },
            { 
                name: "Cangallo", 
                code: "0502",
                districts:[
                    { name: "Cangallo", code: "050201" },
                    { name: "Chuschi", code: "050202" },
                    { name: "Los Morochucos", code: "050203" },
                    { name: "Maria Parado de Bellido", code: "050204" },
                    { name: "Paras", code: "050205" },
                    { name: "Totos", code: "050206" }
                ] 
            },
            { 
                name: "Huanca Sancos", 
                code: "0503",
                districts:[
                    { name: "Sancos", code: "050301" },
                    { name: "Carapo", code: "050302" },
                    { name: "Sacsamarca", code: "050303" },
                    { name: "Santiago de Lucanamarca", code: "050304" }
                ] 
            },
            { 
                name: "Huanta", 
                code: "0504",
                districts:[
                    { name: 'Huanta', code: '050401' },
                    { name: 'Ayahuanco', code: '050402' },
                    { name: 'Huamanguilla', code: '050403' },
                    { name: 'Iguain', code: '050404' },
                    { name: 'Luricocha', code: '050405' },
                    { name: 'Santillana', code: '050406' },
                    { name: 'Sivia', code: '050407' },
                    { name: 'Llochegua', code: '050408' },
                ] 
            },
            { 
                name: "La Mar", 
                code: "0505",
                districts:[
                    { name: "San Miguel", code: "050501" },
                    { name: "Anco", code: "050502" },
                    { name: "Ayna", code: "050503" },
                    { name: "Chilcas", code: "050504" },
                    { name: "Chungui", code: "050505" },
                    { name: "Luis Carranza", code: "050506" },
                    { name: "Santa Rosa", code: "050507" },
                    { name: "Tambo", code: "050508" },
                ] 
            },
            { 
                name: "Lucanas", 
                code: "0506",
                districts:[
                    { name: 'Puquio', code: '050601' },
                    { name: 'Aucara', code: '050602' },
                    { name: 'Cabana', code: '050603' },
                    { name: 'Carmen Salcedo', code: '050604' },
                    { name: 'Chaviña', code: '050605' },
                    { name: 'Chipao', code: '050606' },
                    { name: 'Huac-Huas', code: '050607' },
                    { name: 'Laramate', code: '050608' },
                    { name: 'Leoncio Prado', code: '050609' },
                    { name: 'Llauta', code: '050610' },
                    { name: 'Lucanas', code: '050611' },
                    { name: 'Ocaña', code: '050612' },
                    { name: 'Otoca', code: '050613' },
                    { name: 'Saisa', code: '050614' },
                    { name: 'San Cristobal', code: '050615' },
                    { name: 'San Juan', code: '050616' },
                    { name: 'San Pedro', code: '050617' },
                    { name: 'San Pedro de Palco', code: '050618' },
                    { name: 'Sancos', code: '050619' },
                    { name: 'Santa Ana de Huaycahuacho', code: '050620' },
                    { name: 'Santa Lucia', code: '050621' },
                ] 
            },
            { 
                name: "Parinacochas", 
                code: "0507",
                districts: [
                    { name: "Coracora", code: "050701" },
                    { name: "Chumpi", code: "050702" },
                    { name: "Coronel Castañeda", code: "050703" },
                    { name: "Pacapausa", code: "050704" },
                    { name: "Pullo", code: "050705" },
                    { name: "Puyusca", code: "050706" },
                    { name: "San Francisco de Ravacayco", code: "050707" },
                    { name: "Upahuacho", code: "050708" }
                ] 
            },
            { 
                name: "Paucar del Sara Sara", 
                code: "0508",
                districts:[
                    { name: "Pausa", code: "050801" },
                    { name: "Colta", code: "050802" },
                    { name: "Corculla", code: "050803" },
                    { name: "Lampa", code: "050804" },
                    { name: "Marcabamba", code: "050805" },
                    { name: "Oyolo", code: "050806" },
                    { name: "Pararca", code: "050807" },
                    { name: "San Javier of Alpabamba", code: "050808" },
                    { name: "San Jose de Uchua", code: "050809" },
                    { name: "Sara Sara", code: "050810" },
                ] 
            },
            { 
                name: "Sucre", 
                code: "0509", 
                districts:[  
                    { name: 'Querobamba', code: '050901' },  
                    { name: 'Belen', code: '050902' },  
                    { name: 'Chalcos', code: '050903' },  
                    { name: 'Chilcayoc', code: '050904' },  
                    { name: 'Huacaña', code: '050905' },  
                    { name: 'Morcolla', code: '050906' },  
                    { name: 'Paico', code: '050907' },  
                    { name: 'San Pedro de Larcay', code: '050908' },  
                    { name: 'San Salvador de Quije', code: '050909' },  
                    { name: 'Santiago de Paucaray', code: '050910' },  
                    { name: 'Soras', code: '050911' }
                ]
            },
            { 
                name: "Victor Fajardo", 
                code: "0510",
                districts:[
                    { name: "Huancapi", code: "051001" },
                    { name: "Alcamenca", code: "051002" },
                    { name: "Apongo", code: "051003" },
                    { name: "Asquipata", code: "051004" },
                    { name: "Canaria", code: "051005" },
                    { name: "Cayara", code: "051006" },
                    { name: "Colca", code: "051007" },
                    { name: "Huamanquiquia", code: "051008" },
                    { name: "Huancaraylla", code: "051009" },
                    { name: "Huaya", code: "051010" },
                    { name: "Sarhua", code: "051011" },
                    { name: "Vilcanchos", code: "051012" }
                ] 
            },
            { 
                name: "Vilcas Huaman", 
                code: "0511",
                districts:[
                    { name: "Vilcas Huaman", code: "051101" },
                    { name: "Accomarca", code: "051102" },
                    { name: "Carhuanca", code: "051103" },
                    { name: "Concepcion", code: "051104" },
                    { name: "Huambalpa", code: "051105" },
                    { name: "Independencia", code: "051106" },
                    { name: "Saurama", code: "051107" },
                    { name: "Vischongo", code: "051108" },
                ] 
            }
        ] 
    },
    { 
        code: "06", 
        name: "Cajamarca",
        provinces:[
            { 
                name: 'Cajamarca', 
                code: '0601',
                districts:[
                    { name: "Cajamarca", code: "060101" },
                    { name: "Asuncion", code: "060102" },
                    { name: "Chetilla", code: "060103" },
                    { name: "Cospan", code: "060104" },
                    { name: "Encañada", code: "060105" },
                    { name: "Jesus", code: "060106" },
                    { name: "Llacanora", code: "060107" },
                    { name: "Los Baños del Inca", code: "060108" },
                    { name: "Magdalena", code: "060109" },
                    { name: "Matara", code: "060110" },
                    { name: "Namora", code: "060111" },
                    { name: "San Juan", code: "060112" },
                ] 
            },
            { 
                name: 'Cajabamba', 
                code: '0602',
                districts:[
                    { name: 'Cajabamba', code: '060201' },
                    { name: 'Cachachi', code: '060202' },
                    { name: 'Condebamba', code: '060203' },
                    { name: 'Sitacocha', code: '060204' },
                ] 
            },
            { 
                name: 'Celendin', 
                code: '0603',
                districts:[
                    { name: 'Celendin', code: '060301' },
                    { name: 'Chumuch', code: '060302' },
                    { name: 'Cortegana', code: '060303' },
                    { name: 'Huasmin', code: '060304' },
                    { name: 'Jorge Chavez', code: '060305' },
                    { name: 'Jose Galvez', code: '060306' },
                    { name: 'Miguel Iglesias', code: '060307' },
                    { name: 'Oxamarca', code: '060308' },
                    { name: 'Sorochuco', code: '060309' },
                    { name: 'Sucre', code: '060310' },
                    { name: 'Utco', code: '060311' },
                    { name: 'La Libertad de Pallan', code: '060312' },
                ] 
            },
            { 
                name: 'Chota', 
                code: '0604',
                districts:[
                    { name: 'Chota', code: '060401' },
                    { name: 'Anguia', code: '060402' },
                    { name: 'Chadin', code: '060403' },
                    { name: 'Chiguirip', code: '060404' },
                    { name: 'Chimban', code: '060405' },
                    { name: 'Choropampa', code: '060406' },
                    { name: 'Cochabamba', code: '060407' },
                    { name: 'Conchan', code: '060408' },
                    { name: 'Huambos', code: '060409' },
                    { name: 'Lajas', code: '060410' },
                    { name: 'Llama', code: '060411' },
                    { name: 'Miracosta', code: '060412' },
                    { name: 'Paccha', code: '060413' },
                    { name: 'Pion', code: '060414' },
                    { name: 'Querocoto', code: '060415' },
                    { name: 'San Juan de Licupis', code: '060416' },
                    { name: 'Tacabamba', code: '060417' },
                    { name: 'Tocmoche', code: '060418' },
                    { name: 'Chalamarca', code: '060419' },
                ] 
            },
            { 
                name: 'Contumaza', 
                code: '0605',
                districts:[
                    { name: 'Contumaza', code: '060508' },
                    { name: 'Chilete', code: '060509' },
                    { name: 'Cupisnique', code: '060510' },
                    { name: 'Guzmango', code: '060511' },
                    { name: 'San Benito', code: '060512' },
                    { name: 'Santa Cruz de Toledo', code: '060513' },
                    { name: 'Tantarica', code: '060514' },
                    { name: 'Yonán', code: '060515' }
                ] 
            },
            { 
                name: 'Cutervo', 
                code: '0606',
                districts:[
                    { name: 'Cutervo', code: '060601' },
                    { name: 'Callayuc', code: '060602' },
                    { name: 'Choros', code: '060603' },
                    { name: 'Cujillo', code: '060604' },
                    { name: 'La Ramada', code: '060605' },
                    { name: 'Pimpingos', code: '060606' },
                    { name: 'Querocotillo', code: '060607' },
                    { name: 'San Andrés de Cutervo', code: '060608' },
                    { name: 'San Juan de Cutervo', code: '060609' },
                    { name: 'San Luis de Lucma', code: '060610' },
                    { name: 'Santa Cruz', code: '060611' },
                    { name: 'Santo Domingo de la Capilla', code: '060612' },
                    { name: 'Santo Tomas', code: '060613' },
                    { name: 'Socota', code: '060614' },
                    { name: 'Toribio Casanova', code: '060615' }
                ] 
            },
            { 
                name: 'Hualgayoc', 
                code: '0607',
                districts:[
                    { name: "Bambamarca", code: "060701" },
                    { name: "Chugur", code: "060702" },
                    { name: "Hualgayoc", code: "060703" }
                ] 
            },
            { 
                name: 'Jaen', 
                code: '0608',
                districts:[
                    { name: "Jaen", code: "060801" },
                    { name: "Bellavista", code: "060802" },
                    { name: "Chontali", code: "060803" },
                    { name: "Colasay", code: "060804" },
                    { name: "Huabal", code: "060805" },
                    { name: "Las Pirias", code: "060806" },
                    { name: "Pomahuaca", code: "060807" },
                    { name: "Pucara", code: "060808" },
                    { name: "Sallique", code: "060809" },
                    { name: "San Felipe", code: "060810" },
                    { name: "San Jose del Alto", code: "060811" },
                    { name: "Santa Rosa", code: "060812" },
                ] 
            },
            { 
                name: 'San Ignacio', 
                code: '0609',
                districts:[  
                    { name: 'San Ignacio', code: '060901' },  
                    { name: 'Chirinos', code: '060902' },  
                    { name: 'Huarango', code: '060903' }, 
                    { name: 'La Coipa', code: '060904' },  
                    { name: 'Namballe', code: '060905' },  
                    { name: 'San Jose de Lourdes', code: '060906' },  
                    { name: 'Tabaconas', code: '060907' }
                ] 
            },
            { 
                name: 'San Marcos', 
                code: '0610',
                districts:[
                    { name: 'Pedro Galvez', code: '061001' },  
                    { name: 'Chancay', code: '061002' },  
                    { name: 'Eduardo Villanueva', code: '061003' }, 
                    { name: 'Gregorio Pita', code: '061004' },  
                    { name: 'Ichocan', code: '061005' },  
                    { name: 'Jose Manuel Quiroz', code: '061006' },  
                    { name: 'Jose Sabogal', code: '060907' }
                ] 
            },
            { 
                name: 'San Miguel', 
                code: '0611',
                districts:[
                    { name: "San Miguel", code: "061101" },
                    { name: "Bolivar", code: "061102" },
                    { name: "Calquis", code: "061103" },
                    { name: "Catilluc", code: "061104" },
                    { name: "El Prado", code: "061105" },
                    { name: "La Florida", code: "061106" },
                    { name: "Llapa", code: "061107" },
                    { name: "Nanchoc", code: "061108" },
                    { name: "Niepos", code: "061109" },
                    { name: "San Gregorio", code: "061110" },
                    { name: "San Silvestre de Cochan", code: "061111" },
                    { name: "Tongod", code: "061112" },
                    { name: "Union Agua Blanca", code: "061113" },
                ] 
            },
            { 
                name: 'San Pablo', 
                code: '0612',
                districts:[
                    { name: "San Pablo", code: "061201" },
                    { name: "San Bernardino", code: "061202" },
                    { name: "San Luis", code: "061203" },
                    { name: "Tumbaden", code: "061204" }
                ] 
            },
            { 
                name: 'Santa Cruz', 
                code: '0613',
                districts:[  
                    { name: "Santa Cruz", code: "061301" },  
                    { name: "Andabamba", code: "061302" },  
                    { name: "Catache", code: "061303" },  
                    { name: "Chancaybaños", code: "061304" },  
                    { name: "La Esperanza", code: "061305" },  
                    { name: "Ninabamba", code: "061306" },  
                    { name: "Pulan", code: "061307" },  
                    { name: "Saucepampa", code: "061308" },  
                    { name: "Sexi", code: "061309" },  
                    { name: "Uticyacu", code: "061310" },  
                    { name: "Yauyucan", code: "061311" }
                ] 
            }
        ]
    },
    { 
        code: "07", 
        name: "Callao",
        provinces:[
            { 
                name:"Callao", 
                code: "0701",
                districts:[
                    { name: "Callao", code: "070101" },
                    { name: "Bellavista", code: "070102" },
                    { name: "Carmen de la Legua Reynoso", code: "070103" },
                    { name: "La Perla", code: "070104" },
                    { name: "La Punta", code: "070105" },
                    { name: "Ventanilla", code: "070106" }
                ] 
            }
        ] 
    },
    { 
        code: "08", 
        name: "Cusco",
        provinces:[
            { 
                name: 'Cusco', 
                code: '0801',
                districts:[
                    { name: "Cusco", code: "080101" },
                    { name: "Ccorca", code: "080102" },
                    { name: "Poroy", code: "080103" },
                    { name: "San Jeronimo", code: "080104" },
                    { name: "San Sebastian", code: "080105" },
                    { name: "Santiago", code: "080106" },
                    { name: "Saylla", code: "080107" },
                    { name: "Wanchaq", code: "080108" },
                ] 
            },
            { 
                name: 'Acomayo', 
                code: '0802',
                districts:[
                    { name: 'Acomayo', code: '080201' },
                    { name: 'Acopia', code: '080202' },
                    { name: 'Acos', code: '080203' },
                    { name: 'Mosoc Llacta', code: '080204' },
                    { name: 'Pomacanchi', code: '080205' },
                    { name: 'Rondocan', code: '080206' },
                    { name: 'Sangarara', code: '080207' },
                ] 
            },
            { 
                name: 'Anta', 
                code: '0803',
                districts:[
                    { name: "Anta", code: "080301" },
                    { name: "Ancahuasi", code: "080302" },
                    { name: "Cachimayo", code: "080303" },
                    { name: "Chinchaypujio", code: "080304" },
                    { name: "Huarocondo", code: "080305" },
                    { name: "Limatambo", code: "080306" },
                    { name: "Mollepata", code: "080307" },
                    { name: "Pucyura", code: "080308" },
                    { name: "Zurite", code: "080309" }
                ] 
            },
            { 
                name: 'Calca', 
                code: '0804',
                districts:[
                    { name: 'Calca', code: '080401' },
                    { name: 'Coya', code: '080402' },
                    { name: 'Lamay', code: '080403' },
                    { name: 'Lares', code: '080404' },
                    { name: 'Pisac', code: '080405' },
                    { name: 'San Salvador', code: '080406' },
                    { name: 'Taray', code: '080407' },
                    { name: 'Yanatile', code: '080408' }
                ] 
            },
            { 
                name: 'Canas', 
                code: '0805',
                districts:[
                    { name: "Yanaoca", code: "080501" },
                    { name: "Checca", code: "080502" },
                    { name: "Kunturkanki", code: "080503" },
                    { name: "Langui", code: "080504" },
                    { name: "Layo", code: "080505" },
                    { name: "Pampamarca", code: "080506" },
                    { name: "Quehue", code: "080507" },
                    { name: "Tupac Amaru", code: "080508" },
                ] 
            },
            { 
                name: 'Canchis', 
                code: '0806',
                districts:[
                    { name: "Sicuani", code: "080601" },
                    { name: "Checacupe", code: "080602" },
                    { name: "Combapata", code: "080603" },
                    { name: "Marangani", code: "080604" },
                    { name: "Pitumarca", code: "080605" },
                    { name: "San Pablo", code: "080606" },
                    { name: "San Pedro", code: "080607" },
                    { name: "Tinta", code: "080608" }
                ] 
            },
            { 
                name: 'Chumbivilcas', 
                code: '0807',
                districts:[
                    { name: "Santo Tomas", code: "080701" },
                    { name: "Capacmarca", code: "080702" },
                    { name: "Chamaca", code: "080703" },
                    { name: "Colquemarca", code: "080704" },
                    { name: "Livitaca", code: "080705" },
                    { name: "Llusco", code: "080706" },
                    { name: "Quiñota", code: "080707" },
                    { name: "Velille", code: "080708" }
                ] 
            },
            { 
                name: 'Espinar', 
                code: '0808',
                districts:[
                    { name: "Espinar", code: "080801" },
                    { name: "Condorama", code: "080802" },
                    { name: "Copoparque", code: "080803" },
                    { name: "Ocoruro", code: "080804" },
                    { name: "Pallpata", code: "080805" },
                    { name: "Pichigua", code: "080806" },
                    { name: "Suyckutambo", code: "080807" },
                    { name: "Alto Pichigua", code: "080808" }
                ] 
            },
            { 
                name: 'La Convencion', 
                code: '0809',
                districts:[
                    { name: "Santa Ana", code:"080901"},
                    { name: "Echarate", code: "080902" },
                    { name: "Huayopata", code: "080903" },
                    { name: "Maranura", code: "080904" },
                    { name: "Ocobamba", code: "080905" },
                    { name: "Quellouno", code: "080906" },
                    { name: "Kimbiri", code: "080907" },
                    { name: "Santa Ana", code: "080908" },
                    { name: "Vilcabamba", code: "080909" },
                    { name: "Pichari", code: "080910" },
                ] 
            },
            { 
                name: 'Paruro', 
                code: '0810',
                districts:[
                    { name: 'Paruro', code: '081001' },
                    { name: 'Accha', code: '081002' },
                    { name: 'Ccapi', code: '081003' },
                    { name: 'Colcha', code: '081004' },
                    { name: 'Huanoquite', code: '081005' },
                    { name: 'Omacha', code: '081006' },
                    { name: 'Paccaritambo', code: '081007' },
                    { name: 'Pillpinto', code: '081008' },
                    { name: 'Yaurisque', code: '081009' }
                ] 
            },
            { 
                name: 'Paucartambo', 
                code: '0811',
                districts:[
                    { name: "Paucartambo", code: "081101" },
                    { name: "Caicay", code: "081102" },
                    { name: "Challabamba", code: "081103" },
                    { name: "Colquepata", code: "081104" },
                    { name: "Huancarani", code: "081105" },
                    { name: "Kosñipata", code: "081106" }
                ] 
            },
            { 
                name: 'Quispicanchi', 
                code: '0812',
                districts:[
                    { name: "Urcos", code: "081201" },
                    { name: "Andahuaylillas", code: "081202" },
                    { name: "Camanti", code: "081203" },
                    { name: "Ccarhuayo", code: "081204" },
                    { name: "Ccatca", code: "081205" },
                    { name: "Cusipata", code: "081206" },
                    { name: "Huaro", code: "081207" },
                    { name: "Lucre", code: "081208" },
                    { name: "Marcapata", code: "081209" },
                    { name: "Ocongate", code: "081210" },
                    { name: "Oropesa", code: "081211" },
                    { name: "Quiquijana", code: "081212" },
                ] 
            },
            { 
                name: 'Urubamba', 
                code: '0813',
                districts:[
                    { name: 'Urubamba', code: '081301' },
                    { name: 'Chinchero', code: '081302' },
                    { name: 'Huayllabamba', code: '081303' },
                    { name: 'Machupicchu', code: '081304' },
                    { name: 'Maras', code: '081305' },
                    { name: 'Ollantaytambo', code: '081306' },
                    { name: 'Yucay', code: '081307' }
                ] 
            }
        ] 
    },
    { 
        code: "09", 
        name: "Huancavelica",
        provinces: [
            { 
                name: "Huancavelica", 
                code: "0901",
                districts:[
                    { name: 'Huancavelica', code: '090101' },
                    { name: 'Acobambilla', code: '090102' },
                    { name: 'Acoria', code: '090103' },
                    { name: 'Conayca', code: '090104' },
                    { name: 'Cuenca', code: '090105' },
                    { name: 'Huachocolpa', code: '090106' },
                    { name: 'Huayllahuara', code: '090107' },
                    { name: 'Izcuchaca', code: '090108' },
                    { name: 'Laria', code: '090109' },
                    { name: 'Manta', code: '090110' },
                    { name: 'Mariscal Cáceres', code: '090111' },
                    { name: 'Moya', code: '090112' },
                    { name: 'Nuevo Occoro', code: '090113' },
                    { name: 'Palca', code: '090114' },
                    { name: 'Pilchaca', code: '090115' },
                    { name: 'Vilca', code: '090116' },
                    { name: 'Yauli', code: '090117' },
                    { name: 'Ascensión', code: '090118' },
                ] 
            },
            { 
                name: "Acobamba", 
                code: "0902",
                districts:[
                    { name: "Acobamba", code: "090201" },
                    { name: "Andabamba", code: "090202" },
                    { name: "Anta", code: "090203" },
                    { name: "Caja", code: "090204" },
                    { name: "Marcas", code: "090205" },
                    { name: "Paucara", code: "090206" },
                    { name: "Pomacocha", code: "090207" },
                    { name: "Rosario", code: "090208" }
                ]
             },
            { 
                name: "Angaraes", 
                code: "0903",
                districts:[
                    { name: "Lircay", code: "090301" },
                    { name: "Anchonga", code: "090302" },
                    { name: "Callanmarca", code: "090303" },
                    { name: "Ccochaccasa", code: "090304" },
                    { name: "Chincho", code: "090305" },
                    { name: "Congalla", code: "090306" },
                    { name: "Huanca-Huanca", code: "090307" },
                    { name: "Huayllay Grande", code: "090308" },
                    { name: "Julcamarca", code: "090309" },
                    { name: "San Antonio de Antaparco", code: "090310" },
                    { name: "Santo Tomas de Pata", code: "090311" },
                    { name: "Secclla", code: "090312" },
                ] 
            },
            { 
                name: "Castrovirreyna", 
                code: "0904",
                districts:[
                    { name: 'Castrovirreyna', code: '090401' },
                    { name: 'Arma', code: '090402' },
                    { name: 'Aurahua', code: '090403' },
                    { name: 'Capillas', code: '090404' },
                    { name: 'Chupamarca', code: '090405' },
                    { name: 'Cocas', code: '090406' },
                    { name: 'Huachos', code: '090407' },
                    { name: 'Huamatambo', code: '090408' },
                    { name: 'Mollepampa', code: '090409' },
                    { name: 'San Juan', code: '090410' },
                    { name: 'Santa Ana', code: '090411' },
                    { name: 'Tantara', code: '090412' },
                    { name: 'Ticrapo', code: '090413' }
                ] 
            },
            { 
                name: "Churcampa", 
                code: "0905",
                districts:[
                    { name: 'Churcampa', code: '090501' },
                    { name: 'Anco', code: '090502' },
                    { name: 'Chinchihuasi', code: '090503' },
                    { name: 'El Carmen', code: '090504' },
                    { name: 'La Merced', code: '090505' },
                    { name: 'Locroja', code: '090506' },
                    { name: 'Paucarbamba', code: '090507' },
                    { name: 'San Miguel de Mayocc', code: '090508' },
                    { name: 'San Pedro de Coris', code: '090509' },
                    { name: 'Pachamarca', code: '090510' },
                ] 
            },
            { 
                name: "Huaytara", 
                code: "0906",
                districts:[
                    { name: "Huaytara", code: "090601" },
                    { name: "Ayavi", code: "090602" },
                    { name: "Cordova", code: "090603" },
                    { name: "Huayacundo Arma", code: "090604" },
                    { name: "Laramarca", code: "090605" },
                    { name: "Ocoyo", code: "090606" },
                    { name: "Pilpichaca", code: "090607" },
                    { name: "Querco", code: "090608" },
                    { name: "Quito-Arma", code: "090609" },
                    { name: "San Antonio de Cusicancha", code: "090610" },
                    { name: "San Francisco de Sangayaico", code: "090611" },
                    { name: "San Isidro", code: "090612" },
                    { name: "Santiago de Chocorvos", code: "090613" },
                    { name: "Santiago de Quirahuara", code: "090614" },
                ] 
            },
            { 
                name: "Tayacaja", 
                code: "0907",
                districts:[
                    { name: "Pampas", code: "090701" },
                    { name: "Acostambo", code: "090702" },
                    { name: "Acraquia", code: "090703" },
                    { name: "Ahuaycha", code: "090704" },
                    { name: "Colcabamba", code: "090705" },
                    { name: "Daniel Hernandez", code: "090706" },
                    { name: "Huachocolpa", code: "090707" },
                    { name: "Huando", code: "090708" },
                    { name: "Huaribamba", code: "090709" },
                    { name: "Ñahuimpuquio", code: "090710" },
                    { name: "Pazos", code: "090711" },
                    { name: "Quishuar", code: "090713" },
                    { name: "Salcabamba", code: "090714" },
                    { name: "Salcahuasi", code: "090715" },
                    { name: "San Marcos de Rocchac", code: "090716" },
                    { name: "Surcubamba", code: "090717" },
                    { name: "Tintay Puncu", code: "090718" },
                ] 
            }
        ] 
    },
    { 
        code: "10", 
        name: "Huanuco",
        provinces:[
            { 
                name: "Huanuco", 
                code: "1001",
                districts:[
                    { name: "Huanuco", code: "100101" },
                    { name: "Amarilis", code: "100102" },
                    { name: "Chinchao", code: "100103" },
                    { name: "Churubamba", code: "100104" },
                    { name: "Margos", code: "100105" },
                    { name: "Quisqui", code: "100106" },
                    { name: "San Francisco de Cayran", code: "100107" },
                    { name: "San Pedro de Chaulan", code: "100108" },
                    { name: "Santa Maria del Valle", code: "100109" },
                    { name: "Yarumayo", code: "100110" },
                    { name: "Pillco Marca", code: "100111" },
                ] 
            },
            { 
                name: "Ambo", 
                code: "1002",
                districts:[
                    { name: 'Ambo', code: '100201' },
                    { name: 'Cayna', code: '100202' },
                    { name: 'Colpas', code: '100203' },
                    { name: 'Conchamarca', code: '100204' },
                    { name: 'Huacar', code: '100205' },
                    { name: 'San Francisco', code: '100206' },
                    { name: 'San Rafael', code: '100207' },
                    { name: 'Tomay Kichwa', code: '100208' },
                ] 
            },
            { 
                name: "Dos de Mayo", 
                code: "1003",
                districts:[
                    { name: "La Union", code: "100301" },
                    { name: "Chuquis", code: "100307" },
                    { name: "Marias", code: "100311" },
                    { name: "Pachas", code: "100313" },
                    { name: "Quivilla", code: "100316" },
                    { name: "Ripan", code: "100317" },
                    { name: "Shunqui", code: "100321" },
                    { name: "Sillapata", code: "100322" },
                    { name: "Yanas", code: "100323" },
                ]
            },
            { 
                name: "Huacaybamba", 
                code: "1004",
                districts:[
                    { name: 'Huacaybamba', code: '100401' },
                    { name: 'Canchabamba', code: '100402' },
                    { name: 'Cochabamba', code: '100403' },
                    { name: 'Pinra', code: '100404' }
                ] 
            },
            { 
                name: "Huamalies", 
                code: "1005",
                districts:[
                    { name: "Llata", code: "100501" },
                    { name: "Arancay", code: "100502" },
                    { name: "Chavin de Pariarca", code: "100503" },
                    { name: "Jacas Grande", code: "100504" },
                    { name: "Jircan", code: "100505" },
                    { name: "Miraflores", code: "100506" },
                    { name: "Monzon", code: "100507" },
                    { name: "Punchao", code: "100508" },
                    { name: "Puños", code: "100509" },
                    { name: "Singa", code: "100510" },
                    { name: "Tantamayo", code: "100511" },
                ] 
            },
            { 
                name: "Leoncio Prado", 
                code: "1006",
                districts:[
                    { name: 'Rupa-Rupa', code: '100601' },
                    { name: 'Daniel Alomía Robles', code: '100602' },
                    { name: 'Hermilio Valdizán', code: '100603' },
                    { name: 'Jose Crespo y Castillo', code: '100604' },
                    { name: 'Luyando', code: '100605' },
                    { name: 'Mariano Damaso Beraun', code: '100606' },
                ] 
            },
            { 
                name: "Marañon", 
                code: "1007",
                districts:[
                    { name: "Huacrachuco", code: "100701" },
                    { name: "Cholon", code: "100702" },
                    { name: "San Buenaventura", code: "100703" },
                ]
            },
            { 
                name: "Pachitea", 
                code: "1008",
                districts:[
                    { name: 'Panao', code: '100801' },
                    { name: 'Chaglla', code: '100802' },
                    { name: 'Molino', code: '100803' },
                    { name: 'Umari', code: '100804' },
                ] 
            },
            { 
                name: "Puerto Inca", 
                code: "1009",
                districts:[
                    { name: "Puerto Inca", code: "100901" },
                    { name: "Codo del Pozuzo", code: "100902" },
                    { name: "Honoria", code: "100903" },
                    { name: "Tournavista", code: "100904" },
                    { name: "Yuyapichis", code: "100905" },
                ] 
            },
            { 
                name: "Lauricocha", 
                code: "1010",
                districts:[
                    { name: 'Jesus', code: '101001' },
                    { name: 'Baños', code: '101002' },
                    { name: 'Jivia', code: '101003' },
                    { name: 'Queropalca', code: '101004' },
                    { name: 'Rondos', code: '101005' },
                ] 
            },
            { 
                name: "Yarowilca", 
                code: "1011",
                districts:[
                    { name: "Chavinillo", code: "101101" },
                    { name: "Cahuac", code: "101102" },
                    { name: "Chacabamba", code: "101103" },
                    { name: "Aparicio Pomares", code: "101104" },
                    { name: "Jacas Chico", code: "101105" },
                    { name: "Obas", code: "101106" },
                    { name: "Pampamarca", code: "101107" },
                    { name: "Choras", code: "101108" },
                ] 
            }
        ] 
    },
    { 
        code: "11", 
        name: "Ica",
        provinces: [
            { 
                name: 'Ica', 
                code: '1101',
                districts:[
                    { name: "Ica", code: "110101" },
                    { name: "La Tinguiña", code: "110102" },
                    { name: "Los Aquijes", code: "110103" },
                    { name: "Ocucaje", code: "110104" },
                    { name: "Pachacutec", code: "110105" },
                    { name: "Parcona", code: "110106" },
                    { name: "Pueblo Nuevo", code: "110107" },
                    { name: "Salas", code: "110108" },
                    { name: "San Jose de Los Molinos", code: "110109" },
                    { name: "San Juan Bautista", code: "110110" },
                    { name: "Santiago", code: "110111" },
                    { name: "Subtanjalla", code: "110112" },
                    { name: "Tate", code: "110113" },
                    { name: "Yauca del Rosario", code: "110114" },
                ] 
            },
            { 
                name: 'Chincha', 
                code: '1102',
                districts:[
                    { name: 'Chincha Alta', code: '110201' },
                    { name: 'Alto Laran', code: '110202' },
                    { name: 'Chavin', code: '110203' },
                    { name: 'Chincha Baja', code: '110204' },
                    { name: 'El Carmen', code: '110205' },
                    { name: 'Grocio Prado', code: '110206' },
                    { name: 'Pueblo Nuevo', code: '110207' },
                    { name: 'San Juan de Yanac', code: '110208' },
                    { name: 'San Pedro de Huacarpana', code: '110209' },
                    { name: 'Sunampe', code: '110210' },
                    { name: 'Tambo de Mora', code: '110211' }
                ] 
            },
            { 
                name: 'Nazca', 
                code: '1103',
                districts:[
                    { name: "Nazca", code: "110301" },
                    { name: "Changuillo", code: "110302" },
                    { name: "El Ingenio", code: "110303" },
                    { name: "Marcona", code: "110304" },
                    { name: "Vista Alegre", code: "110305" },
                ] 
            },
            { 
                name: 'Palpa', 
                code: '1104',
                districts:[
                    { name: 'Palpa', code: '110401' },
                    { name: 'Llipata', code: '110402' },
                    { name: 'Rio Grande', code: '110403' },
                    { name: 'Santa Cruz', code: '110404' },
                    { name: 'Tibillo', code: '110405' },
                ] 
            },
            { 
                name: 'Pisco', 
                code: '1105',
                districts:[
                    { name: "Pisco", code: "110501" },
                    { name: "Huancano", code: "110502" },
                    { name: "Humay", code: "110503" },
                    { name: "Independencia", code: "110504" },
                    { name: "Paracas", code: "110505" },
                    { name: "San Andres", code: "110506" },
                    { name: "San Clemente", code: "110507" },
                    { name: "Tupac Amaru Inca", code: "110508" }
                ] 
            },
        ]
    },
    { 
        code: "12", 
        name: "Junin",
        provinces:[
            { 
                name: 'Huancayo', 
                code: '1201',
                districts:[
                    { name: "Huancayo", code: "120101" },
                    { name: "Carhuacallanga", code: "120104" },
                    { name: "Chacapampa", code: "120105" },
                    { name: "Chicche", code: "120106" },
                    { name: "Chilca", code: "120107" },
                    { name: "Chongos Alto", code: "120108" },
                    { name: "Chupuro", code: "1201011" },
                    { name: "Colca", code: "120112" },
                    { name: "Cullhuas", code: "120113" },
                    { name: "El Tambo", code: "120114" },
                    { name: "Huacrapuquio", code: "120116" },
                    { name: "Hualhuas", code: "120117" },
                    { name: "Huancan", code: "120119" },
                    { name: "Huasicancha", code: "120120" },
                    { name: "Huayucachi", code: "120121" },
                    { name: "Ingenio", code: "120122" },
                    { name: "Pariahuanca", code: "120124" },
                    { name: "Pilcomayo", code: "120125" },
                    { name: "Pucara", code: "120126" },
                    { name: "Quichuay", code: "120127" },
                    { name: "Quilcas", code: "120128" },
                    { name: "San Agustin", code: "120129" },
                    { name: "San Jeronimo de Tunan", code: "120130" },
                    { name: "Saño", code: "120132" },
                    { name: "Sapallanga", code: "120133" },
                    { name: "Sicaya", code: "120134" },
                    { name: "Santo Domingo de Acobamba", code: "120135" },
                    { name: "Viques", code: "120136" }
                ] 
            },
            { 
                name: 'Concepcion', 
                code: '1202',
                districts:[  
                    { name: 'Concepcion', code: '120201' },  
                    { name: 'Aco', code: '120202' },  
                    { name: 'Andamarca', code: '120203' },  
                    { name: 'Chambará', code: '120204' },  
                    { name: 'Cochas', code: '120205' },  
                    { name: 'Comas', code: '120206' },  
                    { name: 'Heroinas Toledo', code: '120207' },  
                    { name: 'Manzanares', code: '120208' },  
                    { name: 'Mariscal Castilla', code: '120209' },  
                    { name: 'Matahuasi', code: '120210' },  
                    { name: 'Mito', code: '120211' },  
                    { name: 'Nueve de Julio', code: '120212' },  
                    { name: 'Orcotuna', code: '120213' },  
                    { name: 'San José de Quero', code: '120214' },  
                    { name: 'Santa Rosa de Ocopa', code: '120215' },  
                ] 
            },
            { 
                name: 'Chanchamayo', 
                code: '1203',
                districts:[
                    { name: "Chanchamayo", code: "120301" },
                    { name: "Perene", code: "120302" },
                    { name: "Pichanaqui", code: "120303" },
                    { name: "San Luis de Shuaro", code: "120304" },
                    { name: "San Ramon", code: "120305" },
                    { name: "Vitoc", code: "120306" }
                ] 
            },
            { 
                name: 'Jauja', 
                code: '1204',
                districts:[
                    { name: "Jauja", code: "120401" },
                    { name: "Acolla", code: "120402" },
                    { name: "Apata", code: "120403" },
                    { name: "Ataura", code: "120404" },
                    { name: "Canchayllo", code: "120405" },
                    { name: "Curicaca", code: "120406" },
                    { name: "El Mantaro", code: "120407" },
                    { name: "Huamali", code: "120408" },
                    { name: "Huaripampa", code: "120409" },
                    { name: "Huertas", code: "120410" },
                    { name: "Janjaillo", code: "120411" },
                    { name: "Julcan", code: "120412" },
                    { name: "Leonor Ordoñez", code: "120413" },
                    { name: "Llocllapampa", code: "120414" },
                    { name: "Marco", code: "120415" },
                    { name: "Masma", code: "120416" },
                    { name: "Masma Chicche", code: "120417" },
                    { name: "Molinos", code: "120418" },
                    { name: "Monobamba", code: "120419" },
                    { name: "Muqui", code: "120420" },
                    { name: "Muquiyauyo", code: "120421" },
                    { name: "Paca", code: "120422" },
                    { name: "Paccha", code: "120423" },
                    { name: "Pancan", code: "120424" },
                    { name: "Parco", code: "120425" },
                    { name: "Pomacancha", code: "120426" },
                    { name: "Ricran", code: "120427" },
                    { name: "San Lorenzo", code: "120428" },
                    { name: "San Pedro de Chunan", code: "120429" },
                    { name: "Sausa", code: "120430" },
                    { name: "Sincos", code: "120431" },
                    { name: "Tunan Marca", code: "120432" },
                    { name: "Yauli", code: "120433" },
                    { name: "Yauyos", code: "120434" }
                ] 
            },
            { 
                name: 'Junin', 
                code: '1205',
                districts:[
                    { name: "Junin", code: "120501" },
                    { name: "Carhuamayo", code: "120502" },
                    { name: "Ondores", code: "120503" },
                    { name: "Ulcumayo", code: "120504" },
                ] 
            },
            { 
                name: 'Satipo', 
                code: '1206',
                districts:[
                    { name: "Satipo", code: "120601" },
                    { name: "Coviriali", code: "120602" },
                    { name: "Llaylla", code: "120603" },
                    { name: "Mazamari", code: "120604" },
                    { name: "Pampa Hermosa", code: "120605" },
                    { name: "Pangoa", code: "120606" },
                    { name: "Rio Negro", code: "120607" },
                    { name: "Rio Tambo", code: "120608" },
                    
                ] 
            },
            { 
                name: 'Tarma', 
                code: '1207',
                districts:[
                    { name: "Tarma", code: "120701" },
                    { name: "Acobamba", code: "120702" },
                    { name: "Huaricolca", code: "120703" },
                    { name: "Huasahuasi", code: "120704" },
                    { name: "La Union", code: "120705" },
                    { name: "Palca", code: "120706" },
                    { name: "Palcamayo", code: "120707" },
                    { name: "San Pedro de Cajas", code: "120708" },
                    { name: "Tapo", code: "120709" }
                ] 
            },
            { 
                name: 'Yauli', 
                code: '1208',
                districts:[
                    { name: 'La Oroya', code: '120801' },
                    { name: 'Chacapalpa', code: '120802' },
                    { name: 'Huay-Huay', code: '120803' },
                    { name: 'Marcapomacocha', code: '120804' },
                    { name: 'Morococha', code: '120805' },
                    { name: 'Paccha', code: '120806' },
                    { name: 'Santa Barbara de Carhuacayan', code: '120807' },
                    { name: 'Santa Rosa de Sacco', code: '120808' },
                    { name: 'Suitucancha', code: '120809' },
                    { name: 'Yauli', code: '120810' }
                ] 
            },
            { 
                name: 'Chupaca', 
                code: '1209',
                districts:[
                    { name: 'Chupaca', code: '120901' },
                    { name: 'Ahuac', code: '120902' },
                    { name: 'Chongos Bajo', code: '120903' },
                    { name: 'Huachac', code: '120904' },
                    { name: 'Huamancaca Chico', code: '120905' },
                    { name: 'San Juan de Iscos', code: '120906' },
                    { name: 'San Juan de Jarpa', code: '120907' },
                    { name: 'Tres de Diciembre', code: '120908' },
                    { name: 'Yanacancha', code: '120909' },
                ] 
            },
        ] 
    },
    { 
        code: "13", 
        name: "La Libertad",
        provinces: [
            { 
                name: "Trujillo", 
                code: "1301",
                districts:[
                    { name: 'Trujillo', code: '130101' },
                    { name: 'El Porvenir', code: '130102' },
                    { name: 'Florencia de Mora', code: '130103' },
                    { name: 'Huanchaco', code: '130104' },
                    { name: 'La Esperanza', code: '130105' },
                    { name: 'Laredo', code: '130106' },
                    { name: 'Moche', code: '130107' },
                    { name: 'Poroto', code: '130108' },
                    { name: 'Salaverry', code: '130109' },
                    { name: 'Simbal', code: '130110' },
                    { name: 'Victor Larco Herrera', code: '130111' }
                ] 
            },
            { 
                name: "Ascope", 
                code: "1302",
                districts:[
                    { name: "Ascope", code: "130201" },
                    { name: "Chicama", code: "130202" },
                    { name: "Chocope", code: "130203" },
                    { name: "Magdalena de Cao", code: "130204" },
                    { name: "Paijan", code: "130205" },
                    { name: "Razuri", code: "130206" },
                    { name: "Santiago de Cao", code: "130207" },
                    { name: "Casa Grande", code: "130208" },
                ] 
            },
            { 
                name: "Bolivar", 
                code: "1303",
                districts:[
                    { name: 'Bolivar', code: '130301' },
                    { name: 'Bambamarca', code: '130302' },
                    { name: 'Condormarca', code: '130303' },
                    { name: 'Longotea', code: '130304' },
                    { name: 'Uchumarca', code: '130305' },
                    { name: 'Ucuncha', code: '130306' },
                ] 
            },
            { 
                name: "Chepen", 
                code: "1304",
                districts:[
                    { name: "Chepen", code: "130401" },
                    { name: "Pacanga", code: "130402" },
                    { name: "Pueblo Nuevo", code: "130403" },
                ] 
            },
            { 
                name: "Julcan", 
                code: "1305",
                districts:[
                    { name: 'Julcan', code: '130501' },
                    { name: 'Calamarca', code: '130502' },
                    { name: 'Carabamba', code: '130503' },
                    { name: 'Huaso', code: '130504' }
                ] 
            },
            { 
                name: "Otuzco", 
                code: "1306",
                districts:[
                    { name: "Otuzco", code: "130601" },
                    { name: "Agallpampa", code: "130602" },
                    { name: "Charat", code: "130603" },
                    { name: "Huaranchal", code: "130604" },
                    { name: "La Cuesta", code: "130605" },
                    { name: "Mache", code: "130606" },
                    { name: "Paranday", code: "130607" },
                    { name: "Salpo", code: "130608" },
                    { name: "Sinsicap", code: "130609" },
                    { name: "Usquil", code: "130610" }
                ]
            },
            { 
                name: "Pacasmayo", 
                code: "1307",
                districts:[
                    { name: "San Pedro de Lloc", code: "130701" },
                    { name: "Pacasmayo", code: "130702" },
                    { name: "Jequetepeque", code: "130703" },
                    { name: "Pacasmayo", code: "130704" },
                    { name: "San José", code: "130705" },
                ] 
            },
            { 
                name: "Pataz", 
                code: "1308",
                districts:[
                    { name: 'Tayabamba', code: '130801' },
                    { name: 'Buldibuyo', code: '130802' },
                    { name: 'Chillia', code: '130803' },
                    { name: 'Huancaspata', code: '130804' },
                    { name: 'Huaylillas', code: '130805' },
                    { name: 'Huayo', code: '130806' },
                    { name: 'Ongon', code: '130807' },
                    { name: 'Parcoy', code: '130808' },
                    { name: 'Pataz', code: '130809' },
                    { name: 'Pias', code: '130810' },
                    { name: 'Santiago de Challas', code: '130811' },
                    { name: 'Taurija', code: '130812' },
                    { name: 'Urpay', code: '130813' }
                ] 
            },
            { 
                name: "Sanchez Carrion", 
                code: "1309",
                districts:[
                    { name: 'Huamachuco', code: '130901' },
                    { name: 'Chugay', code: '130902' },
                    { name: 'Cochorco', code: '130903' },
                    { name: 'Curcos', code: '130904' },
                    { name: 'Marcabal', code: '130905' },
                    { name: 'Sanagoran', code: '130906' },
                    { name: 'Sarin', code: '130907' },
                    { name: 'Sartimbamba', code: '130908' },
                ] 
            },
            { 
                name: "Santiago de Chuco", 
                code: "1310",
                districts:[
                    { name: "Santiago de Chuco", code: "131001" },
                    { name: "Angasmarca", code: "131002" },
                    { name: "Cachicadan", code: "131003" },
                    { name: "Mollebamba", code: "131004" },
                    { name: "Mollepata", code: "131005" },
                    { name: "Quiruvilca", code: "131006" },
                    { name: "Santa Cruz de Chuca", code: "131007" },
                    { name: "Sitabamba", code: "131008" }
                ] 
            },
            { 
                name: "Gran Chimu", 
                code: "1311",
                districts:[
                    { name: "Cascas", code: "131101" },
                    { name: "Lucma", code: "131102" },
                    { name: "Marmot", code: "131103" },
                    { name: "Sayapullo", code: "131104" },
                ] 
            },
            { 
                name: "Viru", 
                code: "1312",
                districts:[
                    { name: 'Viru', code: '131201' },
                    { name: 'Chao', code: '131202' },
                    { name: 'Guadalupito', code: '131203' },
                ] 
            }
        ]
    },
    { 
        code: "14", 
        name: "Lambayeque",
        provinces:[
            { 
                name: "Chiclayo", 
                code: "1401",
                districts:[
                    { name: "Chiclayo", code: "140101" },
                    { name: "Chongoyape", code: "140102" },
                    { name: "Eten", code: "010103" },
                    { name: "Eten Puerto", code: "140104" },
                    { name: "Jose Leonardo Ortiz", code: "140105" },
                    { name: "La Victoria", code: "140106" },
                    { name: "Lagunas", code: "140107" },
                    { name: "Monsefu", code: "140108" },
                    { name: "Nueva Arica", code: "140109" },
                    { name: "Oyotun", code: "140110" },
                    { name: "Picsi", code: "140111" },
                    { name: "Pimentel", code: "140112" },
                    { name: "Reque", code: "140113" },
                    { name: "Santa Rosa", code: "140114" },
                    { name: "Saña", code: "140115" },
                    { name: "Cayalti", code: "140116" },
                    { name: "Patapo", code: "140117" },
                    { name: "Pomalca", code: "140118" },
                    { name: "Pucala", code: "140119" },
                    { name: "Tuman", code: "140120" },
                ] 
            },
            { 
                name: "Ferreñafe", 
                code: "1402",
                districts:[
                    { name: "Ferreñafe", code: "140201" },
                    { name: "Cañaris", code: "140202" },
                    { name: "Incahuasi", code: "140203" },
                    { name: "Manuel Antonio Mesones Muro", code: "140204" },
                    { name: "Pitipo", code: "140205" },
                    { name: "Pueblo Nuevo", code: "140206" },
                ] 
            },
            { 
                name: "Lambayeque", 
                code: "1403",
                districts:[
                    { name: 'Lambayeque', code: '140301' },
                    { name: 'Chochope', code: '140302' },
                    { name: 'Illimo', code: '140303' },
                    { name: 'Jayanca', code: '140304' },
                    { name: 'Mochumi', code: '140305' },
                    { name: 'Morrope', code: '140306' },
                    { name: 'Motupe', code: '140307' },
                    { name: 'Olmos', code: '140308' },
                    { name: 'Pacora', code: '140309' },
                    { name: 'Salas', code: '140310' },
                    { name: 'San Jose', code: '140311' },
                    { name: 'Tucume', code: '140312' },
                ] 
            }
        ] 
    },
    { 
        code: "15", 
        name: "Lima",
        provinces:[
            { 
                name: "Lima", 
                code: "1501",
                districts:[
                    { name: "Cercado de Lima", code: "150101" },
                    { name: "Ancon", code: "150102" },
                    { name: "Ate", code: "150103" },
                    { name: "Barranco", code: "150104" },
                    { name: "Breña", code: "150105" },
                    { name: "Carabayllo", code: "150106" },
                    { name: "Chaclacayo", code: "150107" },
                    { name: "Chorrillos", code: "150108" },
                    { name: "Cieneguilla", code: "150109" },
                    { name: "Comas", code: "150110" },
                    { name: "El Agustino", code: "150111" },
                    { name: "Independencia", code: "150112" },
                    { name: "Jesus Maria", code: "150113" },
                    { name: "La Molina", code: "150114" },
                    { name: "La Victoria", code: "150115" },
                    { name: "Lince", code: "150116" },
                    { name: "Los Olivos", code: "150117" },
                    { name: "Lurigancho-Chosica", code: "150118" },
                    { name: "Lurin", code: "150119" },
                    { name: "Magdalena del Mar", code: "150120" },
                    { name: "Magdalena Vieja", code: "150121" },
                    { name: "Miraflores", code: "150122" },
                    { name: "Pachacamac", code: "150123" },
                    { name: "Pucusana", code: "150124" },
                    { name: "Puente Piedra", code: "150125" },
                    { name: "Punta Hermosa", code: "150126" },
                    { name: "Punta Negra", code: "150127" },
                    { name: "Pueblo Libre", code: "1140117"},
                    { name: "Rimac", code: "150128" },
                    { name: "Salamanca", code:"000000"},
                    { name: "San Bartolo", code: "150129" },
                    { name: "San Borja", code: "150130" },
                    { name: "San Isidro", code: "150131" },
                    { name: "San Juan de Lurigancho", code: "150132" },
                    { name: "San Juan de Miraflores", code: "150133" },
                    { name: "San Luis", code: "150134" },
                    { name: "San Martin de Porres", code: "150135" },
                    { name: "San Miguel", code: "150136" },
                    { name: "Santa Anita", code: "150137" },
                    { name: "Santa Maria del Mar", code: "150138" },
                    { name: "Santa Rosa", code: "150139" },
                    { name: "Santiago de Surco", code: "150140" },
                    { name: "Surquillo", code: "150141" },
                    { name: "Villa El Salvador", code: "150142" },
                    { name: "Villa María del Triunfo", code: "150143" }
                ]
                   
            },
            { 
                name: "Barranca",
                code: "1502",
                districts:[
                    { name: "Barranca", code: "150201" },
                    { name: "Paramonga", code: "150202" },
                    { name: "Pativilca", code: "150203" },
                    { name: "Supe", code: "150204" },
                    { name: "Supe Puerto", code: "150205" },
                ]
                   
            },
            { 
                name: "Cajatambo", 
                code: "1503",
                districts:[
                    { name: "Cajatambo", code: "150301" },
                    { name: "Copa", code: "150302" },
                    { name: "Gorgor", code: "150303" },
                    { name: "Huancapón", code: "150304" },
                    { name: "Manas", code: "150305" },
                ]
                   
            },
            { 
                name: "Canta", 
                code: "1504",
                districts:[
                    { name: "Canta", code: "150401" },
                    { name: "Arahuay", code: "150402" },
                    { name: "Huamantanga", code: "150403" },
                    { name: "Huaros", code: "150404" },
                    { name: "Lachaqui", code: "150405" },
                    { name: "San Buenaventura", code: "150406" },
                    { name: "Santa Rosa de Quives", code: "150407" },
                ]
                  
            },
            { 
                name: "Cañete", 
                code: "1505",
                districts:[
                    { name: 'San Vicente', code: '150501' },
                    { name: 'Asia', code: '150502' },
                    { name: 'Calango', code: '150503' },
                    { name: 'Cerro Azul', code: '150504' },
                    { name: 'Chilca', code: '150505' },
                    { name: 'Coayllo', code: '150506' },
                    { name: 'Imperial', code: '150507' },
                    { name: 'Lunahuana', code: '150508' },
                    { name: 'Mala', code: '150509' },
                    { name: 'Nuevo Imperial', code: '150510' },
                    { name: 'Pacaran', code: '150511' },
                    { name: 'Quilmana', code: '150512' },
                    { name: 'San Antonio', code: '150513' },
                    { name: 'San Luis', code: '150514' },
                    { name: 'Santa Cruz de Flores', code: '150515' },
                    { name: 'Zuñiga', code: '150516' }
                ]
                   
            },
            { 
                name: "Huaral", 
                code: "1506",
                districts:[  
                    { name: "Huaral", code: "150601" },  
                    { name: "Atavillos Alto", code: "150602" },  
                    { name: "Atavillos Bajo", code: "150603" },  
                    { name: "Aucallama", code: "150604" },  
                    { name: "Chancay", code: "150605" },  
                    { name: "Ihuari", code: "150606" },  
                    { name: "Lampian", code: "150607" },  
                    { name: "Pacaraos", code: "150608" },  
                    { name: "San Miguel de Acos", code: "150609" },  
                    { name: "Santa Cruz de Andamarca", code: "150610" },  
                    { name: "Sumbilca", code: "150611" },  
                    { name: "Veintisiete de Noviembre", code: "150612" }
                ]
 
            },
            { 
                name: "Huarochiri", 
                code: "1507",
                districts:[
                    { name: "Matucana", code: "150701" },
                    { name: "Antioquia", code: "150702" },
                    { name: "Callahuanca", code: "150703" },
                    { name: "Carampoma", code: "150704" },
                    { name: "Chicla", code: "150705" },
                    { name: "Cuenca", code: "150706" },
                    { name: "Huachupampa", code: "150707" },
                    { name: "Huanza", code: "150708" },
                    { name: "Huarochiri", code: "1507109" },
                    { name: "Lahuaytambo", code: "150710" },
                    { name: "Langa", code: "150711" },
                    { name: "Laraos", code: "150712" },
                    { name: "Mariatana", code: "150713" },
                    { name: "Ricardo Palma", code: "150714" },
                    { name: "San Andres de Tupicocha", code: "150715" },
                    { name: "San Antonio", code: "150716" },
                    { name: "San Bartolome", code: "150717" },
                    { name: "San Damian", code: "150718" },
                    { name: "San Juan de Iris", code: "150719" },
                    { name: "San Juan de Tantaranche", code: "150720" },
                    { name: "San Lorenzo de Quinti", code: "150721" },
                    { name: "San Mateo", code: "150722" },
                    { name: "San Mateo de Otao", code: "150723" },
                    { name: "San Pedro de Casta", code: "150724" },
                    { name: "San Pedro de Huancayre", code: "150725" },
                    { name: "Sangallaya", code: "150726" },
                    { name: "Santa Cruz de Cocachacra", code: "150727" },
                    { name: "Santa Eulalia", code: "150728" },
                    { name: "Santiago de Anchucaya", code: "150729" },
                    { name: "Santiago de Tuna", code: "150730" },
                    { name: "Santo Domingo de los Olleros", code: "150731" },
                    { name: "Surco", code: "150732" },
                ]
                   
            },
            { 
                name: "Huaura", 
                code: "1508",
                districts:[
                    { name: "Huacho", code: "150801" },
                    { name: "Ambar", code: "150802" },
                    { name: "Caleta de Carquin", code: "150803" },
                    { name: "Checras", code: "150804" },
                    { name: "Hualmay", code: "150805" },
                    { name: "Huaura", code: "150806" },
                    { name: "Leoncio Prado", code: "150807" },
                    { name: "Paccho", code: "150808" },
                    { name: "Santa Leonor", code: "150809" },
                    { name: "Santa Maria", code: "150810" },
                    { name: "Sayan", code: "150811" },
                    { name: "Vegueta", code: "150812" }
                ]
                  
            },
            { 
                name: "Oyon", 
                code: "1509",
                districts:[
                    { name: 'Oyon', code: '150901' },
                    { name: 'Andajes', code: '150902' },
                    { name: 'Caujul', code: '150903' },
                    { name: 'Cochamarca', code: '150904' },
                    { name: 'Navan', code: '150905' },
                    { name: 'Pachangara', code: '150906' }
                ]  
            },
            { 
                name: "Yauyos", 
                code: "1510",
                districts:[
                    { name: 'Yauyos', code: '151001' },
                    { name: 'Alis', code: '151002' },
                    { name: 'Ayauca', code: '151003' },
                    { name: 'Ayaviri', code: '151004' },
                    { name: 'Azangaro', code: '151005' },
                    { name: 'Cacra', code: '151006' },
                    { name: 'Carania', code: '151007' },
                    { name: 'Catahuasi', code: '151008' },
                    { name: 'Chocos', code: '151009' },
                    { name: 'Cochas', code: '151010' },
                    { name: 'Colonia', code: '151011' },
                    { name: 'Hongos', code: '151012' },
                    { name: 'Huampara', code: '151013' },
                    { name: 'Huancaya', code: '151014' },
                    { name: 'Huangascar', code: '151015' },
                    { name: 'Huantan', code: '151016' },
                    { name: 'Huañec', code: '151017' },
                    { name: 'Laraos', code: '151018' },
                    { name: 'Lincha', code: '151019' },
                    { name: 'Madean', code: '151020' },
                    { name: 'Miraflores', code: '151021' },
                    { name: 'Omas', code: '151022' },
                    { name: 'Putinza', code: '151023' },
                    { name: 'Quinches', code: '151024' },
                    { name: 'Quinocay', code: '151025' },
                    { name: 'San Joaquin', code: '151026' },
                    { name: 'San Pedro de Pilas', code: '151027' },
                    { name: 'Tanta', code: '151028' },
                    { name: 'Tauripampa', code: '151029' },
                    { name: 'Tomas', code: '151030' },
                    { name: 'Tupe', code: '151031' },
                    { name: 'Viñac', code: '151032' },
                    { name: 'Vitis', code: '151033' },
                ]
                   
            }
        ] 
    },
    { 
        code: "16", 
        name: "Loreto",
        provinces:[
            { 
                name: 'Maynas', 
                code: '1601',
                districts: [
                    { name: 'Iquitos', code: '160101' },
                    { name: 'Alto Nanay', code: '160102' },
                    { name: 'Fernando Lores', code: '160103' },
                    { name: 'Indiana', code: '160104' },
                    { name: 'Las Amazonas', code: '160105' },
                    { name: 'Mazan', code: '160106' },
                    { name: 'Napo', code: '160107' },
                    { name: 'Punchana', code: '160108' },
                    { name: 'Putumayo', code: '160109' },
                    { name: 'Torres Causana', code: '160110' },
                    { name: 'Belen', code: '160112' },
                    { name: 'San Juan Bautista', code: '160113' },
                ]
                   
            },
            { 
                name: 'Alto Amazonas', 
                code: '1602',
                districts:[
                    { name: "Yurimaguas", code: "160201" },
                    { name: "Balsapuerto", code: "160202" },
                    { name: "Barranca", code: "160203" },
                    { name: "Cahuapanas", code: "160204" },
                    { name: "Jeberos", code: "160205" },
                    { name: "Lagunas", code: "160206" },
                    { name: "Manseriche", code: "160207" },
                    { name: "Morona", code: "160208" },
                    { name: "Pastaza", code: "160209" },
                    { name: "Santa Cruz", code: "160210" },
                    { name: "Teniente Cesar Lopez Rojas", code: "160211" }
                ]
                   
            },
            { 
                name: 'Loreto', 
                code: '1603',
                districts:[
                    { name: "Nauta", code: "160301" },
                    { name: "Parinari", code: "160302" },
                    { name: "Tigre", code: "160303" },
                    { name: "Trompeteros", code: "160304" },
                    { name: "Urarinas", code: "160305" },
                ] 
            },
            { 
                name: 'Mariscal Ramon Castilla', 
                code: '1604',
                districts:[
                    { name: "Ramon Castilla", code: "160401" },
                    { name: "Pebas", code: "160402" },
                    { name: "Yabari", code: "160403" },
                    { name: "San Pablo", code: "160404" }
                ]
                   
            },
            { 
                name: 'Requena', 
                code: '1605',
                districts:[
                    { name: "Requena", code: "160501" },
                    { name: "Alto Tapiche", code: "160502" },
                    { name: "Capelo", code: "160503" },
                    { name: "Emilio San Martin", code: "160504" },
                    { name: "Maquia", code: "160505" },
                    { name: "Puinahua", code: "160506" },
                    { name: "Saquena", code: "160507" },
                    { name: "Soplin", code: "160508" },
                    { name: "Tapiche", code: "160509" },
                    { name: "Jenaro Herrera", code: "160510" },
                    { name: "Yaquerana", code: "160511" },
                ]
                   
            },
            { 
                name: 'Ucayali', 
                code: '1606',
                districts:[
                    { name: "Contamana", code: "160601" },
                    { name: "Inahuaya", code: "160602" },
                    { name: "Padre Marquez", code: "160603" },
                    { name: "Pampa Hermosa", code: "160604" },
                    { name: "Sarayacu", code: "160605" },
                    { name: "Vargas Guerra", code: "160606" },
                ]
            },
            { 
                name: 'Datem del Marañon', 
                code: '1607',
                districts:[
                    { name: "Barranca", code: "160701" },
                    { name: "Cahuapanas", code: "160702" },
                    { name: "Manseriche", code: "160703" },
                    { name: "Morona", code: "160704" },
                    { name: "Pastaza", code: "160705" },
                    { name: "Andoas", code: "160706" },
                ]
            },
            { 
                name: 'Putumayo', 
                code: '1608',
                districts:[
                    { name:"Putumayo", code:"160801" },
                    { name:"Rosa Panduro", code:"160802" },
                    { name:"Yaguas", code:"160803" },
                    { name:"Teniente Manuel Clavero", code:"160804" }
                ]
            }
        ]
    },
    { 
        code: "17", 
        name: "Madre de Dios",
        provinces: [
            { 
                name: 'Tambopata', 
                code: '1701',
                districts:[
                    { name: 'Tambopata', code: '170101' },
                    { name: 'Inambari', code: '170102' },
                    { name: 'Las Piedras', code: '170103' },
                    { name: 'Laberinto', code: '170104' }
                ]
                   
            },
            { 
                name: 'Manu', 
                code: '1702',
                districts:[
                    { name: 'Manu', code: '170201' },
                    { name: 'Fitzcarrald', code: '170202' },
                    { name: 'Madre de Dios', code: '170203' },
                    { name: 'Huepetuhe', code: '170204' }
                ] 
            },
            { 
                name: 'Tahuamanu', 
                code: '1703',
                districts:[
                    { name: "Iñapari", code: "170301" },
                    { name: "Iberia", code: "170302" },
                    { name: "Tahuamanu", code: "170303" }
                ]  
            }
        ]
    },
    { 
        code: "18", 
        name: "Moquegua",
        provinces:[
            { 
                name: "Mariscal Nieto", 
                code: "1801",
                districts:[
                    { name: "Moquegua", code: "180101" },
                    { name: "Carumas", code: "180102" },
                    { name: "Cuchumbaya", code: "180103" },
                    { name: "Samegua", code: "180104" },
                    { name: "San Cristobal", code: "180505" },
                    { name: "Torata", code: "180106" }
                ] 
            },
            { 
                name: "General Sanchez Cerro", 
                code: "1802",
                districts:[
                    { name: 'Omate', code: '180201' },
                    { name: 'Chojata', code: '180202' },
                    { name: 'Coalaque', code: '180203' },
                    { name: 'Ichuña', code: '180204' },
                    { name: 'La Capilla', code: '180205' },
                    { name: 'Lloque', code: '180206' },
                    { name: 'Matalaque', code: '180207' },
                    { name: 'Puquina', code: '180208' },
                    { name: 'Quinistaquillas', code: '180209' },
                    { name: 'Ubinas', code: '180210' },
                    { name: 'Yunga', code: '180211' }
                ] 
            },
            { 
                name: "Ilo", 
                code: "1803",
                districts:[
                    { name: 'Ilo', code: '180301' },
                    { name: 'Pacocha', code: '180302' },
                    { name: 'La Capilla', code: '180303' }
                ]
                   
            }
        ] 
    },
    { 
        code: "19", 
        name: "Pasco",
        provinces:[
            { 
                name: "Pasco", 
                code: "1901",
                districts:[
                    { name: 'Chaupimarca', code: '190101' },
                    { name: 'Huachon', code: '190102' },
                    { name: 'Huariaca', code: '190103' },
                    { name: 'Huayllay', code: '190104' },
                    { name: 'Ninacaca', code: '190105' },
                    { name: 'Pallanchacra', code: '190106' },
                    { name: 'Paucartambo', code: '190107' },
                    { name: 'San Francisco de Asis de Yarusyacan', code: '190108' },
                    { name: 'Simon Bolivar', code: '190109' },
                    { name: 'Ticlacayan', code: '190110' },
                    { name: 'Tinyahuarco', code: '190111' },
                    { name: 'Vicco', code: '190112' },
                    { name: 'Yanacancha', code: '190113' },
                ]
                   
            },
            { 
                name: "Daniel Alcides Carrion", 
                code: "1902",
                districts:[
                    { name: 'Yanahuanca', code: '190201' },
                    { name: 'Chacayan', code: '190202' },
                    { name: 'Goyllarisquizga', code: '190203' },
                    { name: 'Paucar', code: '190204' },
                    { name: 'San Pedro de Pillao', code: '190205' },
                    { name: 'Santa Ana de Tusi', code: '190206' },
                    { name: 'Tapuc', code: '190207' },
                    { name: 'Vilcabamba', code: '190208' },
                ]
            },
            { 
                name: "Oxapampa", 
                code: "1903",
                districts:[
                    { name: 'Oxapampa', code: '190301' },
                    { name: 'Chontabamba', code: '190302' },
                    { name: 'Huancabamba', code: '190303' },
                    { name: 'Palcazu', code: '190304' },
                    { name: 'Pozuzo', code: '190305' },
                    { name: 'Puerto Bermudez', code: '190306' },
                    { name: 'Villa Rica', code: '190307' },
                ]                   
            },
        ] 
    },
    { 
        code: "20", 
        name: "Piura",
        provinces:[
            { 
                name: 'Piura', 
                code: '2001',
                districts:[
                    { name: 'Piura', code: '200101' },
                    { name: 'Castilla', code: '200104' },
                    { name: 'Catacaos', code: '200105' },
                    { name: 'Cura Mori', code: '200107' },
                    { name: 'El Tallan', code: '200108' },
                    { name: 'La Arena', code: '200109' },
                    { name: 'La Union', code: '200110' },
                    { name: 'Las Lomas', code: '200111' },
                    { name: 'Tambo Grande', code: '200114' },
                ] 
            },
            { 
                name: 'Ayabaca', 
                code: '2002',
                districts:[
                    { name: "Ayabaca", code: "200201" },
                    { name: "Frias", code: "200202" },
                    { name: "Jilili", code: "200203" },
                    { name: "Lagunas", code: "200204" },
                    { name: "Montero", code: "200205" },
                    { name: "Pacaipampa", code: "200206" },
                    { name: "Paimas", code: "200207" },
                    { name: "Sapillica", code: "200208" },
                    { name: "Sicchez", code: "200209" },
                    { name: "Suyo", code: "200210" }
                ]    
            },
            { 
                name: 'Huancabamba', 
                code: '2003',
                districts:[
                    { name: "Huancabamba", code: "200301" },
                    { name: "Canchaque", code: "200302" },
                    { name: "El Carmen de la Frontera", code: "200303" },
                    { name: "Huarmaca", code: "200304" },
                    { name: "Lalaquiz", code: "200305" },
                    { name: "San Miguel de El Faique", code: "200306" },
                    { name: "Sondor", code: "200307" },
                    { name: "Sondorillo", code: "200308" }
                ]
                   
            },
            { 
                name: 'Morropon', 
                code: '2004',
                districts:[
                    { name: 'Chulucanas', code: '200401' },
                    { name: 'Buenos Aires', code: '200402' },
                    { name: 'Chalaco', code: '200403' },
                    { name: 'La Matanza', code: '200404' },
                    { name: 'Morropon', code: '200405' },
                    { name: 'Salitral', code: '200406' },
                    { name: 'San Juan de Bigote', code: '200407' },
                    { name: 'Santa Catalina de Mossa', code: '200408' },
                    { name: 'Santo Domingo', code: '200409' },
                    { name: 'Yamango', code: '200410' }
                ]
                   
            },
            { 
                name: 'Paita', 
                code: '2005',
                districts:[
                    { name: 'Paita', code: '200501' },
                    { name: 'Amotape', code: '200502' },
                    { name: 'Arenal', code: '200503' },
                    { name: 'Colan', code: '200504' },
                    { name: 'La Huaca', code: '200505' },
                    { name: 'Tamarindo', code: '200506' },
                    { name: 'Vichayal', code: '200507' },
                ]
                   
            },
            { 
                name: 'Sullana', 
                code: '2006',
                districts: [
                    { name: "Sullana", code: "200601" },
                    { name: "Bellavista", code: "200602" },
                    { name: "Ignacio Escudero", code: "200603" },
                    { name: "Lancones", code: "200604" },
                    { name: "Marcavelica", code: "200605" },
                    { name: "Miguel Checa", code: "200606" },
                    { name: "Querecotillo", code: "200607" },
                    { name: "Salitral", code: "200608" }
                ]
                  
            },
            { 
                name: 'Talara', 
                code: '2007',
                districts: [
                    { name: "Pariñas", code: "200701" },
                    { name: "El Alto", code: "200702" },
                    { name: "La Brea", code: "200703" },
                    { name: "Lobitos", code: "200704" },
                    { name: "Los Organos", code: "200705" },
                    { name: "Mancora", code: "200706" }
                ]
                  
            },
            { 
                name: 'Sechura', 
                code: '2008',
                districts:[
                    { name: "Sechura", code: "200801" },
                    { name: "Bellavista de la Unión", code: "200802" },
                    { name: "Bernal", code: "200803" },
                    { name: "Cristo Nos Valga", code: "200804" },
                    { name: "Vice", code: "200805" },
                    { name: "Rinconada Llicuar", code: "200806" },
                ]
                  
            }
        ] 
    },
    { 
        code: "21", 
        name: "Puno",
        provinces:[
            { 
                name: "Puno", 
                code: "2101",
                districts: [
                    { name: 'Puno', code: '210101' },
                    { name: 'Acora', code: '210102' },
                    { name: 'Amantani', code: '210103' },
                    { name: 'Atuncolla', code: '210104' },
                    { name: 'Capachica', code: '210105' },
                    { name: 'Chucuito', code: '210106' },
                    { name: 'Coata', code: '210107' },
                    { name: 'Huata', code: '210108' },
                    { name: 'Mañazo', code: '210109' },
                    { name: 'Paucarcolla', code: '210110' },
                    { name: 'Pichacani', code: '210111' },
                    { name: 'Plateria', code: '210112' },
                    { name: 'San Antonio de Esquilache', code: '210113' },
                    { name: 'Tiquillaca', code: '210114' },
                    { name: 'Vilque', code: '210115' },
                ]
                   
            },
            { 
                name: "Azangaro", 
                code: "2102",
                districts:[
                    { name: "Azangaro", code: "210201" },
                    { name: "Achaya", code: "210202" },
                    { name: "Arapa", code: "210203" },
                    { name: "Asillo", code: "210204" },
                    { name: "Caminaca", code: "210205" },
                    { name: "Chupa", code: "210206" },
                    { name: "Jose Domingo Choquehuanca", code: "210207" },
                    { name: "Muñani", code: "210208" },
                    { name: "Potoni", code: "210209" },
                    { name: "Saman", code: "210210" },
                    { name: "San Anton", code: "210211" },
                    { name: "San Jose", code: "210212" },
                    { name: "San Juan de Salinas", code: "210213" },
                    { name: "Santiago de Pupuja", code: "210214" },
                    { name: "Tirapata", code: "210215" }
                ]
                   
            },
            { 
                name: "Carabaya", 
                code: "2103",
                districts:[
                    { name: "Macusani", code: "210301" },
                    { name: "Ajoyani", code: "210302" },
                    { name: "Ayapata", code: "210303" },
                    { name: "Coasa", code: "210304" },
                    { name: "Corani", code: "210305" },
                    { name: "Crucero", code: "210306" },
                    { name: "Ituata", code: "210307" },
                    { name: "Ollachea", code: "210308" },
                    { name: "San Gaban", code: "210309" },
                    { name: "Usicayos", code: "210310" },
                ]
                  
             },
            { 
                name: "Chucuito", 
                code: "2104",
                districts:[
                    { name: 'Juli', code: '210401' },
                    { name: 'Desaguadero', code: '210402' },
                    { name: 'Huacullani', code: '210403' },
                    { name: 'Kelluyo', code: '210404' },
                    { name: 'Pisacoma', code: '210405' },
                    { name: 'Pomata', code: '210406' },
                    { name: 'Zepita', code: '210407' },
                ]
                   
            },
            { 
                name: "El Collao", 
                code: "2105",
                districts: [
                    { name: 'Llave', code: '210501' },
                    { name: 'Capazo', code: '210502' },
                    { name: 'Pilcuyo', code: '210503' },
                    { name: 'Santa Rosa', code: '210504' },
                    { name: 'Conduriri', code: '210505' },
                ]
            },
            { 
                name: "Huancane", 
                code: "2106",
                districts:[
                    { name: 'Huancane', code: '210608' },
                    { name: 'Cojata', code: '210609' },
                    { name: 'Huatasani', code: '210610' },
                    { name: 'Inchupalla', code: '210611' },
                    { name: 'Pusi', code: '210612' },
                    { name: 'Rosaspata', code: '210613' },
                    { name: 'Taraco', code: '210614' },
                    { name: 'Vilque Chico', code: '210615' },
                ]
                  
            },
            { 
                name: "Lampa", 
                code: "2107",
                districts: [
                    { name: "Lampa", code: "210701" },
                    { name: "Cabanilla", code: "210702" },
                    { name: "Calapuja", code: "210703" },
                    { name: "Nicasio", code: "210704" },
                    { name: "Ocuviri", code: "210705" },
                    { name: "Palca", code: "210706" },
                    { name: "Paratia", code: "210707" },
                    { name: "Pucara", code: "210708" },
                    { name: "Santa Lucia", code: "210709" },
                    { name: "Vilavila", code: "210710" }
                ]
                  
            },
            { 
                name: "Melgar", 
                code: "2108",
                districts: [
                    { name: 'Ayaviri', code: '210801' },
                    { name: 'Antauta', code: '210802' },
                    { name: 'Cupi', code: '210803' },
                    { name: 'Llalli', code: '210804' },
                    { name: 'Macari', code: '210805' },
                    { name: 'Nuñoa', code: '210806' },
                    { name: 'Orurillo', code: '210807' },
                    { name: 'Santa Rosa', code: '210808' },
                    { name: 'Umachiri', code: '210809' },
                ]
                   
            },
            { 
                name: "Moho", 
                code: "2109",
                districts:[
                    { name: "Moho", code: "210901" },
                    { name: "Conima", code: "210902" },
                    { name: "Huayrapata", code: "210903" },
                    { name: "Tilali", code: "210904" }
                ]
                   
            },
            { 
                name: "San Antonio de Putina", 
                code: "2110",
                districts:[
                    { name: "San Antonio de Putina", code: "211001" },
                    { name: "Ananea", code: "211002" },
                    { name: "Pedro Vilca Apaza", code: "211003" },
                    { name: "Quilcapuncu", code: "211004" },
                    { name: "Sina", code: "211005" }
                ]
                   
            },
            { 
                name: "San Roman", 
                code: "2111",
                districts:[
                    { name: "Juliaca", code: "211101" },
                    { name: "Cabana", code: "211102" },
                    { name: "Cabanillas", code: "211103" },
                    { name: "Caracoto", code: "211104" },
                ]
             },
            { 
                name: "Sandia", 
                code: "2112",
                districts: [  
                    { name: "Sandia", code: "211201" },  
                    { name: "Cuyocuyo", code: "211202" },  
                    { name: "Limbani", code: "211203" },  
                    { name: "Patambuco", code: "211204" },  
                    { name: "Phara", code: "211205" },  
                    { name: "Quiaca", code: "211206" },  
                    { name: "San Juan del Oro", code: "211207" },  
                    { name: "Yanahuaya", code: "211208" },  
                    { name: "Alto Inambari", code: "211209" },
                ]

            },
            { 
                name: "Yunguyo", 
                code: "2113",
                districts: [
                    { name: "Yunguyo", code: "211301" },
                    { name: "Anapia", code: "211302" },
                    { name: "Copani", code: "211303" },
                    { name: "Cuturapi", code: "211304" },
                    { name: "Ollaraya", code: "211305" },
                    { name: "Tinicachi", code: "211306" },
                    { name: "Unicachi", code: "211307" }
                ]
                   
            }
        ] 
    },
    { 
        code: "22", 
        name: "San Martin",
        provinces:[
            { 
                name: 'Moyobamba', 
                code: '2201',
                districts:[
                    { name: 'Moyobamba', code: '220101' },
                    { name: 'Calzada', code: '220102' },
                    { name: 'Habana', code: '220103' },
                    { name: 'Jepelacio', code: '220104' },
                    { name: 'Soritor', code: '220105' },
                    { name: 'Yantalo', code: '220106' }
                ]
                   
            },
            { 
                name: 'Bellavista', 
                code: '2202',
                districts:[
                    { name: 'Bellavista', code: '220201' },
                    { name: 'Alto Biavo', code: '220202' },
                    { name: 'Bajo Biavo', code: '220203' },
                    { name: 'Huallaga', code: '220204' },
                    { name: 'San Pablo', code: '220205' },
                    { name: 'San Rafael', code: '220206' }
                ]
                   
            },
            { 
                name: 'El Dorado', 
                code: '2203',
                districts: [
                    { name: 'San Jose de Sisa', code: '220301' },
                    { name: 'Agua Blanca', code: '220302' },
                    { name: 'San Martin', code: '220303' },
                    { name: 'Santa Rosa', code: '220304' },
                    { name: 'Shatoja', code: '220305' },
                ]
            },
            { 
                name: 'Huallaga', 
                code: '2204',
                districts:  [
                    { name: 'Saposoa', code: '220401' },
                    { name: 'Alto Saposoa', code: '220402' },
                    { name: 'El Eslabon', code: '220403' },
                    { name: 'Piscoyacu', code: '220404' },
                    { name: 'Sacanche', code: '220405' },
                    { name: 'Tingo de Saposoa', code: '220406' }
                ]
            },
            { 
                name: 'Lamas', 
                code: '2205',
                districts: [
                    { name: "Lamas", code: "220501" },
                    { name: "Alonso de Alvarado", code: "220502" },
                    { name: "Barranquita", code: "220503" },
                    { name: "Caynarachi", code: "220504" },
                    { name: "Cuñumbuqui", code: "220505" },
                    { name: "Pinto Recodo", code: "220506" },
                    { name: "Rumisapa", code: "220507" },
                    { name: "San Roque de Cumbaza", code: "220508" },
                    { name: "Shanao", code: "220509" },
                    { name: "Tabalosos", code: "220510" },
                    { name: "Zapatero", code: "220511" }
                ]
                  
            },
            { 
                name: 'Mariscal Cáceres', 
                code: '2206',
                districts:[
                    { name: "Juanjui", code: "220601" },
                    { name: "Campanilla", code: "220602" },
                    { name: "Huicungo", code: "220603" },
                    { name: "Pachiza", code: "220604" },
                    { name: "Pajarillo", code: "220605" }
                ]
                   
            },
            { 
                name: 'Picota', 
                code: '2207',
                districts: [
                    { name: "Picota", code: "220701" },
                    { name: "Buenos Aires", code: "220702" },
                    { name: "Caspisapa", code: "220703" },
                    { name: "Pilluana", code: "220704" },
                    { name: "Pucacaca", code: "220705" },
                    { name: "San Cristobal", code: "220706" },
                    { name: "San Hilarion", code: "220707" },
                    { name: "Shamboyacu", code: "220708" },
                    { name: "Tingo de Ponasa", code: "220709" },
                    { name: "Tres Unidos", code: "220710" },
                ]
                   
            },
            { 
                name: 'Rioja', 
                code: '2208',
                districts:[
                    { name: 'Rioja', code: '220801' },
                    { name: 'Awajun', code: '220802' },
                    { name: 'Elias Soplin Vargas', code: '220803' },
                    { name: 'Nueva Cajamarca', code: '220804' },
                    { name: 'Pardo Miguel', code: '220805' },
                    { name: 'Posic', code: '220806' },
                    { name: 'San Fernando', code: '220807' },
                    { name: 'Yorongos', code: '220808' },
                    { name: 'Yuracyacu', code: '220809' }
                ]
                   
            },
            { 
                name: 'San Martin', 
                code: '2209',
                districts: [
                    { name: 'Tarapoto', code: '220901' },
                    { name: 'Alberto Leveau', code: '220902' },
                    { name: 'Cacatachi', code: '220903' },
                    { name: 'Chazuta', code: '220904' },
                    { name: 'Chipurana', code: '220905' },
                    { name: 'El Porvenir', code: '220906' },
                    { name: 'Huimbayoc', code: '220907' },
                    { name: 'Juan Guerra', code: '220908' },
                    { name: 'La Banda del Shilcayo', code: '220909' },
                    { name: 'Morales', code: '220910' },
                    { name: 'Papaplaya', code: '220911' },
                    { name: 'San Antonio', code: '220912' },
                    { name: 'Sauce', code: '220913' },
                    { name: 'Shapaja', code: '220914' },
                ]
                   
            },
            { 
                name: 'Tocache', 
                code: '2210',
                districts: [
                    { name: "Tocache", code: "221001" },
                    { name: "Nuevo Progreso", code: "221002" },
                    { name: "Polvora", code: "221003" },
                    { name: "Shunte", code: "221004" },
                    { name: "Uchiza", code: "221005" },
                ]
                   
            },
        ] 
    },
    { 
        code: "23", 
        name: "Tacna",
        provinces:[
            { 
                name: 'Tacna', 
                code: '2301',
                districts:[
                    { name: "Tacna", code: "230101" },
                    { name: "Alto de la Alianza", code: "230102" },
                    { name: "Calana", code: "230103" },
                    { name: "Ciudad Nueva", code: "230104" },
                    { name: "Inclan", code: "230105" },
                    { name: "Pachia", code: "230106" },
                    { name: "Palca", code: "230107" },
                    { name: "Pocollay", code: "230108" },
                    { name: "Sama", code: "230109" },
                    { name: "Coronel Gregorio Albarracin Lanchipa", code: "230110" }
                ]
                   
            },
            { 
                name: 'Candarave', 
                code: '2302',
                districts: [
                    { name: "Candarave", code: "230201" },
                    { name: "Cairani", code: "230202" },
                    { name: "Camilaca", code: "230203" },
                    { name: "Curibaya", code: "230204" },
                    { name: "Huanuara", code: "230205" },
                    { name: "Quilahuani", code: "230206" }
                ]
                  
            },
            { 
                name: 'Jorge Basadre', 
                code: '2303',
                districts: [
                    { name: 'Locumba', code: '230301' },
                    { name: 'Ilabaya', code: '230302' },
                    { name: 'Ite', code: '230303' }
                ]
                   
            },
            { 
                name: 'Tarata', 
                code: '2304',
                districts: [
                    { name: "Tarata", code: "230401" },
                    { name: "Chucatamani", code: "230402" },
                    { name: "Estique", code: "230403" },
                    { name: "Estique-Pampa", code: "230403" },
                    { name: "Sitajara", code: "230404" },
                    { name: "Susapaya", code: "230405" },
                    { name: "Tarucachi", code: "230406" },
                    { name: "Ticaco", code: "230407" }
                ]
                   
            },
        ] 
    },
    { 
        code: "24", 
        name: "Tumbes",
        provinces:[
            { 
                name: "Tumbes", 
                code: "2401",
                districts:[
                    { name: 'Tumbes', code: '2401' },
                    { name: 'Corrales', code: '2402' },
                    { name: 'La Cruz', code: '2403' },
                    { name: 'Pampas de Hospital', code: '2404' },
                    { name: 'San Jacinto', code: '2405' },
                    { name: 'San Juan de la Virgen', code: '2406' }
                ]
                   
            },
            { 
                name: "Contralmirante Villar", 
                code: "2402",
                districts:[  
                    { name: "Zorritos", code: "240201" },  
                    { name: "Casitas", code: "240202" },
                ] 
            },
            { 
                name: "Zarumilla",
                code: "2403",
                districts:[
                    { name: "Zarumilla", code: "240301" },
                    { name: "Aguas Verdes", code: "240302" },
                    { name: "Matapalo", code: "240303" },
                    { name: "Papayal", code: "240304" }
                ]
                   
            },
        ] 
    },
    { 
        code: "25", 
        name: "Ucayali",
        provinces:[
            { 
                name: "Coronel Portillo", 
                code: "2501",
                districts: [
                    { name: "Calleria", code: "250101" },
                    { name: "Campoverde", code: "250102" },
                    { name: "Iparia", code: "250103" },
                    { name: "Masisea", code: "250104" },
                    { name: "Yarinacocha", code: "250105" },
                    { name: "Nueva Requena", code: "250106" }
                ]
                   
            },
            { 
                name: "Atalaya", 
                code: "2502",
                districts: [
                    { name: 'Raymondi', code: '250201' },
                    { name: 'Sepahua', code: '25022' },
                    { name: 'Tahuania', code: '250203' },
                    { name: 'Yurua', code: '250204' }
                ]
                   
            },
            { 
                name: "Padre Abad", 
                code: "2503",
                districts: [
                    { name: 'Padre Abad', code: '250301' },
                    { name: 'Irazola', code: '250302' },
                    { name: 'Curimana', code: '250303' },
                ]
            },
            { 
                name: "Purus", 
                code: "2504",
                districts: [
                    { name: "Puru", code: "250401" }
                ] 
            }
        ] 
    },
    {
        code:26,
        name:"Tarapoto",
        provinces:[
            {
                name:"Tarapoto",
                code:"2601",
                districts:[
                    { name:"Tarapoto",code:"260101"}
                ]
            }
        ]
    }
  ];

  export const zones = {
    "centro": [
      "Cercado de Lima", "Lima", "Breña", "Pueblo Libre", "Jesús María", "La Victoria", 
      "Lince", "San Luis", "Magdalena", "Barranco", "San Miguel", "San Borja", 
      "Surquillo", "San Isidro", "Miraflores"
    ],
    "sur": [
      "Santiago de Surco", "Chorrillos", "San Juan de Miraflores", 
      "Villa María del Triunfo", "Villa el Salvador"
    ],
    "norte": [
      "Comas", "San Martín de Porres", "Independecia", "Los Olivos", "Rimac", "San Martin de Porres"
    ],
    "callao": [
      "Bellavista", "Callao", "Carmen de la Legua", "La Perla", "La Punta"
    ],
    "este": [
      "San Juan de Lurigancho", "El Agustino", "Santa Anita", "La Molina", "Ate", 
      "Lurigancho"
    ],
    "periferico": [
      "Comas 2", "Lurin", "Ventanilla", "Cieneguilla", "San Juan de Lurigancho 2", 
      "Puente Piedra", "Chosica", "Pachacamac"
    ]
  };
  